import * as React from "react";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { Redirect } from "react-router";
import instance from "../../helpers/newUrl";
import { debounce } from "lodash";
import axios from "../../helpers/axios";
import { isUatEnvironment } from "../../helpers/uatMasking";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  TableHead,
  TextareaAutosize,
} from "@mui/material";
import {
  Grid,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  ButtonGroup,
  Button,
  Avatar,
  Menu,
  MenuItem,
  Typography,
  FormControl,
  OutlinedInput,
  TextField,
  Tooltip,
  Chip,
  Divider,
  Modal,
  Box,
  Select,
  InputLabel,
  Backdrop,
  CircularProgress,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Dialog,
  DialogActions,
  DialogTitle,
  Autocomplete,
  DialogContent,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Stack,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation, WithTranslation } from "react-i18next";
// import Customers from './Customers';
import NeighbourhoodHeader from "./NeighbourhoodHeader";
import {
  DataGrid,
  GridRowParams,
  GridActionsCellItem,
  GridCellParams,
} from "@mui/x-data-grid";
import {
  EditOutlined,
  Add,
  Security as SecurityIcon,
  FileCopy as FileCopyIcon,
  KeyboardArrowLeftRounded,
  MoreHorizOutlined,
  AccountBalanceWalletOutlined,
  VisibilityOutlined,
  CloseOutlined,
  Co2,
  Forest,
  PaymentsOutlined,
  LocalGasStationOutlined,
  DeleteOutlined,
  DeleteOutline,
  ExpandMore,
} from "@mui/icons-material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  Timeline,
  TimelineOppositeContent,
} from "@mui/lab";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  p: 4,
};

export interface IProps {
  user: {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    selectedHierarchies: any[];
    selectedHierarchyIds: any[];
  };
}

export interface IState {
  customer_id: string;
  newNoteText: string;
  customer_details: any;
  pageSize: number;
  anchorEl: any;
  payments: any[];
  customerPickups: any[];
  pickupRowCount: any;
  customerTickets: any[];
  customerTicketsType: string;
  customerTicketsPageSize: number;
  customerTicketsRowCount: number;
  showAddTransaction: boolean;
  communityHistory: { community_name: string; join_date: string }[];
  showPickupDetails: boolean;
  selectedRow: any;
  showAddPickup: boolean;
  transaction_type: string;
  transaction_amount: number;
  transaction_comment: string;
  pickup_date?: string | null;
  pickup_zone: string;
  pickup_slot: string;
  beneficiaries_data: any;
  filter: any;
  type: any;
  showLoader: boolean;
  routes: any;
  alertsData: any;
  paymentRowCount: any;
  showEditCustomer: boolean;
  customerEditDetails: any;
  availableBagsWithCustomers: any;
  pausePickupData: any;
  qrCodeData: any;
  showCustomDateFilter: boolean;
  ecoStatData: any;
  alertsMode: any;
  showAlerts: boolean;
  showPauseModal: boolean;
  pause_start_date: any;
  pause_end_date: any;
  alertBody: any;
  showAvailableBags: boolean;
  barcode: any;
  bag_type: any;
  pickupFilter: any;
  showRemoveUserFromCommunityConfirmationDialog: boolean;
  community_id: any;
  showAddUserToCommunityDialog: any;
  transactions: any[];
  transactionRowCount: number;
  paymentsPageSize: number;
  transactionsPageSize: number;
  showDeleteBarcodeConfirmationDialog: boolean;
  barcodeToBeDeleted: any;
  alertResponse: any;
  showTransactionDetails: boolean;
  transactionDetails: any;
  pickup_details: any;
  pickup_id: any;
  bagDetails: any;
  showEditBag: boolean;
  showAddBag: boolean;
  bagUid: any;
  bagWeight: any;
  forceAddBag: any;
  pause_remarks:string;
  selectedBarcodes: string[];
  showDeleteBagsConfirmationDialog: boolean;
  availableBagsWithUsersPageSize: number;
  showAddBarcodeSetModal: boolean;
  showHistoryPopup: boolean;
  activeBagsOpen: boolean;
  deletedBagsOpen: boolean;
  showNotesPopup: boolean;
  notes: {
    sender: string;
    timestamp: string;
    message: string;
  }[];
  editingNoteIndex: number | null;
  showDeleteBagConfirmation: boolean,
  bagToDelete: null,
}

class CustomerDetails extends React.Component<
  RouteComponentProps<any> & IProps & WithTranslation,
  IState
> {
  constructor(props: RouteComponentProps & IProps & WithTranslation) {
    super(props);
    this.state = {
      customer_id: this.props.match.params.id,
      newNoteText: "",
      customer_details: {
        // "id": 1,
        // "customer_name": "Azim C",
        // "balance": "30,884.00",
        // "billing_amount": "30,000.00",
        // "mrf_customer_id": "KK 0502 ",
        // "route": {
        //     "name": "WR Supratman New",
        //     "joined_at": "2021-04-23"
        // },
        // "mobile": "8199934561",
        // "email": "pratama@gmail.com",
        // "generator": "Small Generator",
        // "customers": 65,
        // "address": "A-21, Ground and 1 Floor",
        // "driver": "Widhi Dan Dodik",
        // "payment_agent": "Widhi Dan Dodik",
        // "house_number": "Azim House",
        // "referral_code": "azim100",
        // "status": "Active"
      },
      pageSize: 10,
      anchorEl: null,
      payments: [],
      customerPickups: [],
      pickupRowCount: 0,
      customerTickets: [],
      customerTicketsType: "all",
      customerTicketsPageSize: 5,
      customerTicketsRowCount: 0,
      showAddTransaction: false,
      showPauseModal: false,
      pause_start_date: null,
      pause_end_date: null,
      communityHistory: [],
      showPickupDetails: false,
      selectedRow: null,
      showAddPickup: false,
      transaction_type: "",
      pause_remarks: "",
      transaction_amount: 0,
      transaction_comment: "",
      pickup_date: null,
      activeBagsOpen: true,
      deletedBagsOpen: false,
      pickup_zone: "",
      pickup_slot: "",
      beneficiaries_data: [],
      filter: "",
      type: "",
      showLoader: false,
      routes: [],
      alertsData: [],
      paymentRowCount: "",
      showEditCustomer: false,
      customerEditDetails: {},
      availableBagsWithCustomers: [],
      pausePickupData: [],
      qrCodeData: [],
      showCustomDateFilter: false,
      ecoStatData: [],
      alertsMode: "",
      showAlerts: false,
      alertBody: "",
      showAvailableBags: false,
      barcode: "",
      bag_type: "",
      pickupFilter: "",
      showRemoveUserFromCommunityConfirmationDialog: false,
      community_id: "",
      showAddUserToCommunityDialog: false,
      transactions: [],
      transactionRowCount: 0,
      paymentsPageSize: 5,
      transactionsPageSize: 5,
      showDeleteBarcodeConfirmationDialog: false,
      barcodeToBeDeleted: null,
      alertResponse: "",
      showTransactionDetails: false,
      showHistoryPopup: false,
      showNotesPopup: false,
      transactionDetails: null,
      pickup_details: {
        bags: [],
      },
      pickup_id: null,
      bagDetails: [],
      showEditBag: false,
      showAddBag: false,
      bagUid: "",
      bagWeight: "",
      forceAddBag: "",
      selectedBarcodes: [],
      showDeleteBagsConfirmationDialog: false,
      notes: [],
      editingNoteIndex: null,
      availableBagsWithUsersPageSize: 100,
      showAddBarcodeSetModal: false,
      showDeleteBagConfirmation: false,
      bagToDelete: null,
    };
  }
  notesEndRef = React.createRef<HTMLDivElement>();
  bagsTableRef = React.createRef<HTMLTableElement>();
  public componentDidMount(): void {
    // axios.get(`routes`).then(response => {
    //     this.setState({ routes: response.data.data })
    // });

    this.fetchRoutes();
    setTimeout(() => {
      this.fetchCustomerDetails();
    }, 300);
    this.fetchNotifications();
    this.fetchCustomerBeneficiaries();
    this.fetchCustomerPickups();
    this.fetchCustomerTickets();
    document.addEventListener("copy", this.handleClipboardCopy);
    // this.fetchCustomerWalletPayments();
  }

  public fetchCustomerTickets = (
    page: number = 0,
    limit: number = this.state.customerTicketsPageSize
  ) => {
    this.setState({ showLoader: true });
    let body = {
      hierarchies: this.props.user.selectedHierarchyIds,
      type:
        this.state.customerTicketsType !== "all"
          ? this.state.customerTicketsType
          : "",
      customer_id: this.state.customer_id,
      page: page + 1,
      limit: limit,
    };
    axios
      .post("listAllTickets", body, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response: any) => {
        if (response.data.success) {
          let data = response.data.data.data || [];
          this.setState({
            customerTickets: data,
            customerTicketsRowCount: response.data.data.total,
            showLoader: false,
          });
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          let errors = response.data.errors;
          for (var error in errors) {
            toast.error(errors[error][0], {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error(error.response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  public handleClipboardCopy = (event: ClipboardEvent) => {
    event.preventDefault();

    const selection = window.getSelection();
    if (!selection) return;

    // Extract selected text
    const selectedText = selection.toString().trim();
    console.log(selectedText);

    // If there's no selection, do nothing
    if (!selectedText) return;

    // Split the text into lines
    const lines = selectedText.split("\n").map((line) => line.trim());

    // Group lines into records of 7 fields each
    const formattedText = [];
    for (let i = 0; i < lines.length; i += 5) {
      const record = lines.slice(i, i + 5).join("\t"); // Join 7 fields with tabs
      formattedText.push(record); // Add the formatted record to the array
    }

    // Join the records with new lines to keep each record on its own row
    const finalFormattedText = formattedText.join("\n");

    // Copy to clipboard
    event.clipboardData?.setData("text/plain", finalFormattedText);
  };

  public fetchCustomerDetails() {
    this.setState({ showLoader: true });
    let data = {
      hierarchies: this.props.user.selectedHierarchyIds,
    };
    axios
      .get(`getCustomerDetails/` + this.state.customer_id, { params: data })
      .then((response) => {
        this.setState({ showLoader: false });
        let data = response.data.data;
        // console.log("data", data);
        this.setState({ availableBagsWithCustomers: data.barcodes });
        // console.log("bagData", this.state.availableBagsWithCustomers);
        if (response.data.success) {
          this.setState({ showLoader: false });
          // console.log("respo",response.data.data);
          this.setState({
            pausePickupData: response.data.data.unavailability,
            qrCodeData: response.data.data.qrcodes,
            ecoStatData: response.data.data.stats,
          });
          let routeDetails = this.state.routes?.filter(
            (el: any) => el.id == data.community?.community_id
          );
          // console.log("routeDetails", routeDetails);
          let customer_details = {
            id: data.id,
            customer_name: data.name,
            balance:
              data.wallet && data.wallet.balance
                ? data.wallet.balance.total
                : 0,
            route: {
              name: routeDetails[0]?.name,
              joined_at: data.community?.join_date,
            },
            mobile: data.phone,
            joining_date: data.created_at,
            email: data.email,
            address: data.extra ? data.extra.location : "",
            wallet_id: data.wallet_id ? data.wallet_id : null,
            status: data.is_active ? "Active" : "Inactive",
            pause_pickup_status: data.pause_pickup_status,
            city_id: data.hierarchy_id ? data.hierarchy_id : "",
            city_name: data.city_name ? data.city_name : "",
            customer_address: data.extra ? data.extra.location : "",
            route_id: data.community ? data.community.community_id : "",
            about: data.extra ? data.extra.about : "",
            referral_code: data.extra ? data.extra.referral_code : "",
            // "about": (data.extra && data.extra.about) ? data.extra.about : "NA",
            // "referral_code": (data.extra && data.extra.referral_code) ? data.extra.referral_code : "NA",
            // mrf: data.extra ? data.extra.about : "",
          };
          this.setState({ customer_details: customer_details }, () => {
            this.fetchCustomerWalletPayments();
            this.fetchCustomerWalletTransactions();
          });
          // console.log("data", this.state.availableBagsWithCustomers);
          // console.log("data", this.state.customer_details);
          // this.fetchCustomerWalletPayments();
          //   this.fetchPickups();
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          let errors = response.data.errors;
          for (var error in errors) {
            toast.error(errors[error][0], {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        console.log("error", error);
        toast.error(error.response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  }

  public fetchRoutes(hierarchies: any = this.props.user.selectedHierarchyIds) {
    axios
      .get(`allCommunitiesLite`, { params: { hierarchies: hierarchies } })
      .then((response) => {
        let data: any = response.data.data;
        // let routes: any = [];
        // data.map((route: any) => {
        //   routes[route.id] = {
        //     id: route.id,
        //     route: route.name,
        //     generator: route.type,
        //   };
        // });
        this.setState({ routes: data });
        // console.log("routes", this.state.routes);
      });
  }

  public fetchNotifications = () => {
    this.setState({ showLoader: true });
    let body = {
      hierarchies: this.props.user.selectedHierarchyIds,
      user_id: this.state.customer_id,
      limit: this.state.pageSize,
      mode: this.state.alertsMode,
    };
    axios
      .post(`getCustomerNotifications`, body, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response: any) => {
        if (response.data.success) {
          this.setState({
            alertsData: response.data.data.data,
            showLoader: false,
          });
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          let errors = response.data.errors;
          for (var error in errors) {
            toast.error(errors[error][0], {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error(error.response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  public fetchCustomerBeneficiaries = () => {
    let data = {
      hierarchies: this.props.user.selectedHierarchyIds,
      user_id: this.state.customer_id,
    };
    axios
      .post("getCustomerBeneficiaries", data, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response: any) => {
        if (response.data.success) {
          // console.log("beneficiaries_data", response.data.data);
          this.setState({ beneficiaries_data: response.data.data });
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          let errors = response.data.errors;
          for (var error in errors) {
            toast.error(errors[error][0], {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error(error.response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  public fetchCustomerWalletPayments = (
    page: any = 0,
    limit: any = this.state.paymentsPageSize
  ) => {
    this.setState({ showLoader: true });
    let body = {
      hierarchies: this.props.user.selectedHierarchyIds,
      limit: this.state.paymentsPageSize,
      page: page + 1,
      wallet_id: this.state.customer_details?.wallet_id,
    };
    axios
      .post(`getCustomerWalletPayments`, body, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response: any) => {
        if (response.data.success) {
          this.setState({
            payments: [...response.data.data.data],
            paymentRowCount: response.data.data.total,
            showLoader: false,
          });
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          let errors = response.data.errors;
          for (var error in errors) {
            toast.error(errors[error][0], {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error(error.response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  public fetchCustomerWalletTransactions = (
    page: any = 0,
    limit: any = this.state.transactionsPageSize
  ) => {
    this.setState({ showLoader: true });
    let body = {
      hierarchies: this.props.user.selectedHierarchyIds,
      limit: this.state.transactionsPageSize,
      page: page + 1,
      wallet_id: this.state.customer_details?.wallet_id,
    };
    axios
      .post(`getCustomerWalletTransactions`, body, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response: any) => {
        if (response.data.success) {
          this.setState({
            transactions: [...response.data.data.data],
            transactionRowCount: response.data.data.total,
            showLoader: false,
          });
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          let errors = response.data.errors;
          for (var error in errors) {
            toast.error(errors[error][0], {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error(error.response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  public fetchCustomerPickups = (
    page: any = 0,
    limit: any = this.state.pageSize
  ) => {
    this.setState({ showLoader: true });
    let body = {
      hierarchies: this.props.user.selectedHierarchyIds,
      limit: limit,
      page: page + 1,
      user_id: this.state.customer_id,
      pickup_status: this.state.pickupFilter,
    };
    axios
      .post("filterPickups", body, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response: any) => {
        if (response.data.success) {
          // console.log(response.data.data.data);
          this.setState({
            customerPickups: response.data.data.data,
            pickupRowCount: response.data.data.total,
            showLoader: false,
          });
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          let errors = response.data.errors;
          for (var error in errors) {
            toast.error(errors[error][0], {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error(error.response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  public handleRemoveUserFromCommunity() {
    let customer_id: any = this.state.customer_id;
    if (customer_id) {
      this.setState({ showLoader: true });
      let payload: any = {
        user_id: customer_id,
        community_id: this.state.customer_details.route_id,
      };
      axios
        .post(`removeUserFromCommunity`, payload)
        .then((response) => {
          if (response.data.success) {
            this.setState(
              {
                showRemoveUserFromCommunityConfirmationDialog: false,
                showLoader: false,
              },
              () => this.fetchCustomerDetails()
            );
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            this.setState({
              showRemoveUserFromCommunityConfirmationDialog: false,
              showLoader: false,
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showRemoveUserFromCommunityConfirmationDialog: false,
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  }

  public handleAddUserToCommunity() {
    let customer_id: any = this.state.customer_id;
    let community_id: any = this.state.community_id;
    if (customer_id && community_id) {
      this.setState({ showLoader: true });
      let payload: any = {
        user_id: customer_id,
        community_id: community_id,
      };
      axios
        .post(`addUserToCommunity`, payload)
        .then((response) => {
          if (response.data.success) {
            this.setState(
              {
                showAddUserToCommunityDialog: false,
                showLoader: false,
                community_id: "",
              },
              () => this.fetchCustomerDetails()
            );
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            this.setState({
              showAddUserToCommunityDialog: false,
              showLoader: false,
              community_id: "",
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showAddUserToCommunityDialog: false,
            showLoader: false,
            community_id: "",
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  }

  public handleDeleteBarcode() {
    let barcode: any = this.state.barcodeToBeDeleted;
    if (barcode) {
      this.setState({ showLoader: true });
      let payload: any = {
        barcode: barcode.barcode,
        user_id: barcode.user_id,
      };
      axios
        .post(`deleteBarcode`, payload)
        .then((response) => {
          if (response.data.success) {
            this.setState(
              {
                showDeleteBarcodeConfirmationDialog: false,
                showLoader: false,
                barcodeToBeDeleted: null,
              },
              () => this.fetchCustomerDetails()
            );
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            this.setState({
              showDeleteBarcodeConfirmationDialog: false,
              showLoader: false,
              barcodeToBeDeleted: null,
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showDeleteBarcodeConfirmationDialog: false,
            showLoader: false,
            barcodeToBeDeleted: null,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  }
  handlePausePickup = () => {
  if (!this.state.pause_start_date || !this.state.pause_end_date) {
    toast.error("Select start and end date");
    return;
  }

  this.setState({ showLoader: true });

  axios.post("pauseServiceByAdmin", {
    user_id: this.state.customer_id,
    start_date: this.state.pause_start_date,
    end_date: this.state.pause_end_date,
    remarks: this.state.pause_remarks 
  })
  .then((response: any) => {
    this.setState({ showLoader: false });

    if (response.data.success) {
      toast.success(response.data.msg);

      this.setState({
        showPauseModal: false,
        pause_start_date: null,
        pause_end_date: null,
        pause_remarks: "" 
      });

      // 🔥 IMPORTANT — refresh list
      this.fetchCustomerDetails();
    } else {
      toast.error(response.data.msg);
    }
  })
  .catch((error) => {
    this.setState({ showLoader: false });
    toast.error(error.response?.data?.msg || "Something went wrong");
  });
};

  handleRowClick = (params: GridRowParams) => {
    this.setState(
      {
        pickup_id: params.id,
        showPickupDetails: true,
        selectedRow: params.row,
      },
      () => {
        this.fetchPickupDetails();
      }
    );
  };

  closeModal = () => {
    this.setState({ showPickupDetails: false, selectedRow: null });
  };
  /*handleBarcodeSelection = (event: React.ChangeEvent<HTMLInputElement>, barcode: string) => {
        if (event.target.checked) {
            this.setState(prevState => ({
                selectedBarcodes: [...prevState.selectedBarcodes, barcode]
            }));
        } else {
            this.setState(prevState => ({
                selectedBarcodes: prevState.selectedBarcodes.filter(b => b !== barcode)
            }));
        }
    };*/
  handleDeleteSelectedBags = () => {
    console.log("Deleting bags:", this.state.selectedBarcodes);
    this.setState({ showDeleteBagsConfirmationDialog: true });
  };
  fetchCommunityHistory = () => {
    const { customer_id } = this.state;
    this.setState({ showLoader: true });
    instance
      .get(`/community-history/${customer_id}`)
      .then((response) => {
        if (response.data && response.data.success) {
          this.setState({
            communityHistory: response.data.data,
            showLoader: false,
          });
        } else {
          this.setState({ showLoader: false });
          toast.error("Failed to fetch community history", {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error("Failed to fetch community history", {
          position: "top-right",
        });
      });
  };
  fetchNotes = () => {
    const { customer_id } = this.state;

    instance
      .get(`/adminNotesList`, {
        params: { user_id: customer_id },
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((response) => {
        if (response.data && response.data.notes) {
          const notes = response.data.notes.map((note: any) => ({
            sender: note.added_by_user_name,
            timestamp: note.added_at,
            message: note.note,
          }));
          this.setState({ notes }, () => {
            if (this.notesEndRef.current) {
              this.notesEndRef.current.scrollIntoView({ behavior: "smooth" });
            }
          });
        } else {
          toast.error("Failed to fetch notes", { position: "top-right" });
        }
      })
      .catch((error) => {
        console.error("Error fetching notes:", error);
        const msg =
          error.response?.data?.msg ||
          error.message ||
          "An unexpected error occurred while fetching notes.";
        toast.error(msg, { position: "top-right" });
        this.setState({ notes: [] });
      });
  };
  handleSendNote = () => {
    const { newNoteText, customer_id } = this.state;
    if (!newNoteText.trim()) return;

    instance
      .post(
        `/adminNotesAdd`,
        {
          user_id: customer_id,
          note: newNoteText.trim(),
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )
      .then((response) => {
        if (response.data && response.data.note) {
          this.fetchNotes();
          this.setState({ newNoteText: "" });
          toast.success("Note added", { position: "top-right" });
        }
      })
      .catch((error) => {
        toast.error("Failed to add note", { position: "top-right" });
      });
  };

  handleEditNote = (index: any) => {
    const note = this.state.notes[index];
    this.setState({ newNoteText: note.message, editingNoteIndex: index });
  };

  handleDeleteNote = (index: any) => {
    const updatedNotes = [...this.state.notes];
    updatedNotes.splice(index, 1);
    this.setState({ notes: updatedNotes });
  };
  //   debouncedSetNoteText = debounce((value: string) => {
  //     this.setState({ newNoteText: value });
  //   }, 200);
  //   handleNoteTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //     const value = e.target.value;
  //     // Only update if necessary
  //     this.debouncedSetNoteText(value);
  //   };

  handleConfirmDeleteBags = () => {
    if (this.state.selectedBarcodes.length) {
      this.setState({ showLoader: true });
      let barcodes = this.state.selectedBarcodes.map(
        (item: any) => item.barcode
      );
      let payload: any = {
        user_id: this.state.customer_details.id,
        barcodes: barcodes,
      };
      axios
        .post(`deleteBarcodes`, payload)
        .then((response) => {
          if (response.data.success) {
            this.setState(
              {
                showDeleteBagsConfirmationDialog: false,
                showLoader: false,
                selectedBarcodes: [],
              },
              () => this.fetchCustomerDetails()
            );
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            this.setState({
              showDeleteBagsConfirmationDialog: false,
              showLoader: false,
              selectedBarcodes: [],
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showDeleteBagsConfirmationDialog: false,
            showLoader: false,
            selectedBarcodes: [],
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    } else {
      toast.error("Select atleast one Barcode", {
        position: "top-right",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    //    console.log("Deleting bags:", this.state.selectedBarcodes);
    //     this.setState({
    //         selectedBarcodes: [],
    //         showDeleteBagsConfirmationDialog: false
    //     }, () => {
    //         this.fetchCustomerDetails();
    //     });
  };
  handleViewMore = () => {
    const { selectedRow } = this.state;
    if (selectedRow) {
      this.props.history.push(
        `/operations/batch-pickups/group-pickups/pickup-details/${selectedRow.id}`
      );
    }
  };

  fetchPickupDetails = () => {
    this.setState({ showLoader: true });
    const body = {
      hierarchies: this.props.user.selectedHierarchyIds,
    };

    axios
      .get(`pickupDetails/${this.state.pickup_id}`, { params: body })
      .then((response: any) => {
        if (response.data.success) {
          this.setState({
            pickup_details: response.data.data,
            showLoader: false,
          });
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, { theme: "colored" });
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error(
          error.response?.data?.msg || "Error fetching pickup details",
          { theme: "colored" }
        );
      });
  };

  public render() {
    if (!localStorage.getItem("token")) {
      return <Redirect to="/login" />;
    }
    const { t } = this.props;
    const open = Boolean(this.state.anchorEl);
    const maskedDetailValueSx = isUatEnvironment
      ? {
          filter: "blur(4px)",
          opacity: 0.5,
          userSelect: "none",
        }
      : undefined;
    const renderMaskedDetailValue = (value: React.ReactNode) => (
      <Box component="span" sx={maskedDetailValueSx}>
        {value}
      </Box>
    );
    const handleCustomerMoreOptions = (
      event: React.MouseEvent<HTMLElement>
    ) => {
      this.setState({ anchorEl: event.currentTarget });
    };
    const TOTAL_HEIGHT = 648;
    const HEADER_HEIGHT = 64; 
    let activeHeight: number | 'auto' = 0;
    let deletedHeight: number | 'auto' = 0;
    if (!this.state.activeBagsOpen && !this.state.deletedBagsOpen) {
      activeHeight = 0;
      deletedHeight = 0;
    }
    else if (this.state.activeBagsOpen && this.state.deletedBagsOpen) {
      activeHeight = (TOTAL_HEIGHT - HEADER_HEIGHT * 2) / 2;
      deletedHeight = activeHeight;
    }
    else if (this.state.activeBagsOpen) {
      
      activeHeight = TOTAL_HEIGHT - HEADER_HEIGHT * 2;
      deletedHeight = 0;
    }
    else {
      
      deletedHeight = 'auto';  
      activeHeight = 0;
    }
    const handleAddTransaction = () => {
      this.setState({ showLoader: true });
      let body = {
        user_id: this.state.customer_id,
        hierarchies: this.props.user.selectedHierarchyIds,
        title: this.state.transaction_comment,
        amount: this.state.transaction_amount,
        type: this.state.transaction_type,
      };
      axios
        .post("addMoneyToWallet", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showLoader: false, showAddTransaction: false });
            toast.success("Transaction added", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCustomerWalletPayments();
          } else {
            this.setState({ showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showEditCustomer: false,
            customerEditDetails: {},
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleAddPickup = () => {
      this.setState({ showAddPickup: false });
      toast.success("Pickup added", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    };

    const closeCustomerMoreOptions = () => {
      setTimeout(() => {
        this.setState({ anchorEl: null });
      }, 1);
    };

    const handleEditCustomer = (data: any) => {
      closeCustomerMoreOptions();
      // this.setState({
      //   showEditCustomer: true,
      //   customer_name: data.customer_name,
      //   mobile: data.mobile,
      //   email: data.email,
      //   city_id: data.city_id,
      //   customer_address: data.customer_address,
      //   route_id: data.route_id,
      //   mrf: data.mrf,
      //   billing_amount: data.billing_amount,
      // });
      this.setState({
        showEditCustomer: true,
        customerEditDetails: {
          customer_name: data.customer_name,
          mobile: data.mobile,
          email: data.email,
          city_id: data.city_id,
          customer_address: data.customer_address,
          // route_id: data.route_id,
          about: data.about,
          referral_code: data.referral_code,
        },
      });
    };

    const toggleCustomerStatus = (customerId: any, status: string) => {
      this.setState({ showLoader: true });
      let options = {
        customer_id: customerId,
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      axios
        .post(`toggleCustomerStatus`, options)
        .then((response: any) => {
          this.setState({ showLoader: false, anchorEl: null });
          toast.success(
            t("Customer") +
              (status == "Active" ? " Deactivated " : " Activated ") +
              t("Successfully"),
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
          this.fetchCustomerDetails();
        })
        .catch((error) => {
          this.setState({
            showLoader: false,
          });
          toast.error(error.response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleHierarchyChange = (city_id: any) => {
      this.setState({
        customerEditDetails: {
          ...this.state.customerEditDetails,
          city_id: city_id,
        },
      });
      this.fetchRoutes([city_id]);
    };

    const handleUpdateCustomer = () => {
      this.setState({ showLoader: true });
      let body: any = {
        customer_id: this.state.customer_id,
        // billing_amount: this.state.billing_amount,
        // community_id: this.state.customerEditDetails?.route_id,
        name: this.state.customerEditDetails?.customer_name,
        // phone: this.state.customerEditDetails?.mobile,
        // email: this.state.customerEditDetails?.email,
        location: this.state.customerEditDetails?.customer_address,
        about: this.state.customerEditDetails?.about,
        referral_code: this.state.customerEditDetails?.referral_code,
        // hierarchies: [this.state.customerEditDetails?.city_id],
      };
      if (
        this.state.customer_details.city_id !=
        this.state.customerEditDetails?.city_id
      ) {
        body.hierarchies = [this.state.customerEditDetails?.city_id];
      }
      if (
        [
          "vijay@bintix.com",
          "kedarnath@bintix.com",
          "satheesh@bintix.com",
        ].includes(this.props.user.email)
      ) {
        body.phone = this.state.customerEditDetails?.mobile;
        body.email = this.state.customerEditDetails?.email;
      }
      // if (this.state.customer_details.mrf != this.state.mrf) {
      //   data.about = this.state.mrf;
      // }
      // let url = "editCustomer";
      // if (axios.defaults.baseURL) {
      //   let currentBaseURL: string = axios.defaults.baseURL;
      //   currentBaseURL = currentBaseURL.split("/").slice(0, 3).join("/");
      //   url = currentBaseURL + url;
      // }
      axios
        .post("editCustomer", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          this.setState({
            showEditCustomer: false,
            //   customer_name: "",
            //   mobile: "",
            //   email: "",
            //   city_id: "",
            //   customer_address: "",
            //   route_id: "",
            customerEditDetails: {},
            showLoader: false,
          });
          if (response.data.success) {
            toast.success(t("Customer Updated Successfully"), {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCustomerDetails();
          } else {
            this.setState({ showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showEditCustomer: false,
            customerEditDetails: {},
            //   customer_name: "",
            //   mobile: "",
            //   email: "",
            //   city_id: "",
            //   customer_address: "",
            //   route_id: "",
            //   mrf: "",
            //   billing_amount: 0,
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const addBarcodeToUser = () => {
      this.setState({ showLoader: true });
      let data = {
        barcode: this.state.barcode,
        bag_type: this.state.bag_type,
        hierarchies: this.props.user.selectedHierarchyIds,
        user_id: this.state.customer_id,
      };
      axios
        .post("addBarcodetoUser", data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showLoader: false, showAvailableBags: false });
            toast.success("Bag added", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            //callback
            this.fetchCustomerDetails();
          } else {
            this.setState({ showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showEditCustomer: false,
            customerEditDetails: {},
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const addBarcodeSetToUser = () => {
      this.setState({ showLoader: true });
      let data = {
        barcode: this.state.barcode,
        bag_type: this.state.bag_type,
        hierarchies: this.props.user.selectedHierarchyIds,
        user_id: this.state.customer_id,
      };
      axios
        .post("addBarcodeSetToUser", data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showLoader: false, showAddBarcodeSetModal: false });
            toast.success("Set Added", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            //callback
            this.fetchCustomerDetails();
          } else {
            this.setState({ showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showEditCustomer: false,
            customerEditDetails: {},
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const paymentColumns: any = [
      {
        headerName: "Id",
        field: "id",
        width: 80,
      },
      {
        headerName: "Type",
        field: "type",
        width: 150,
      },
      {
        headerName: "Title",
        field: "title",
        width: 200,
      },
      {
        headerName: "Amount",
        field: "amount",
        type: "number",
        width: 100,
        renderCell: (params: GridCellParams) =>
          renderMaskedDetailValue(params.value),
      },
      // {
      //     headerName: "Collected By",
      //     field: "collected_by",
      //     width: 200
      // },
      {
        headerName: "Updated At",
        field: "updated_at",
        width: 170,
      },
      // {
      //     headerName: "Edit",
      //     field: "action",
      //     width: 80,
      //     renderCell: (params: GridCellParams) => (
      //         <IconButton type='button' size='small' sx={{ outline: 'none !important', width: '20px !important' }}><EditOutlined /></IconButton>
      //     )
      // }
    ];

    const transactionColumns: any = [
      {
        headerName: "Id",
        field: "id",
        width: 80,
      },
      {
        headerName: "Type",
        field: "redeem_type",
        width: 150,
        hide: true,
      },
      {
        headerName: "Title",
        field: "title",
        width: 150,
      },
      {
        headerName: "Amount",
        field: "amount",
        type: "number",
        width: 80,
        renderCell: (params: GridCellParams) =>
          renderMaskedDetailValue(params.value),
      },
      {
        headerName: "Status",
        field: "status",
        type: "number",
        width: 100,
      },
      {
        headerName: "Updated At",
        field: "updated_at",
        width: 170,
      },
    ];

    const bagsWithUserColumn: any = [
      /*{
                field: 'select',
                headerName: 'Select',
                width: 65,
                renderCell: (params: GridCellParams) => (
                    <Checkbox
                        checked={this.state.selectedBarcodes.includes(params.row.barcode)}
                        onChange={(event:any) => this.handleBarcodeSelection(event, params.row.barcode)}
                        disabled={!params.row.is_active} 
                    />
                ),
            },*/

      {
        headerName: "Barcode",
        field: "barcode",
        width: 150,
      },
      {
        headerName: "Date",
        field: "linked_date",
        width: 100,
      },
      {
        headerName: "Type",
        field: "bag_type",
        width: 100,
      },
      {
        headerName: "Warehouse",
        field: "reached_warehouse",
        width: 100,
        align: "center",
        renderCell: (params: GridCellParams) => (
          <Typography
            className={
              params.row.reached_warehouse != 0
                ? "statusTextSuccess"
                : "statusTextError"
            }
            component={"span"}
          >
            {params.row.reached_warehouse != 0 ? "Yes" : "No"}
          </Typography>
        ),
      },
      {
        headerName: "Action",
        field: "action",
        width: 80,
        align: "center",
        renderCell: (params: GridCellParams) => {
          if (params.row.is_active) {
            return (
              <IconButton
                type="button"
                color="error"
                size="small"
                sx={{ outline: "none !important" }}
                onClick={() =>
                  this.setState({
                    showDeleteBarcodeConfirmationDialog: true,
                    barcodeToBeDeleted: params.row,
                  })
                }
              >
                <DeleteOutlined />
              </IconButton>
            );
          } else {
            return <span>&nbsp;</span>;
          }
        },
      },
      // Additional columns if needed
    ];

    const beneficiaries_columns = [
      {
        headerName: "ID",
        field: "id",
        width: 100,
      },
      {
        headerName: "Wallet ID",
        field: "wallet_id",
        width: 150,
        renderCell: (params: GridCellParams) =>
          renderMaskedDetailValue(params.value),
      },
      {
        headerName: "Name",
        field: "name",
        width: 200,
        renderCell: (params: GridCellParams) =>
          renderMaskedDetailValue(params.value),
      },
      {
        headerName: "Type",
        field: "type",
        width: 120,
        renderCell: (params: GridCellParams) =>
          renderMaskedDetailValue(params.value),
      },
      {
        headerName: "Bank A/C Number",
        field: "bank_ac_number",
        width: 180,
        renderCell: (params: GridCellParams) => (
          renderMaskedDetailValue(
            <Typography variant="body2">
              {params.row.bank_ac_number == null
                ? "-"
                : params.row.bank_ac_number}
            </Typography>
          )
        ),
      },
      {
        headerName: "Bank IFSC Code",
        field: "bank_ifsc",
        width: 150,
        renderCell: (params: GridCellParams) => (
          renderMaskedDetailValue(
            <Typography variant="body2">
              {params.row.bank_ifsc == null ? "-" : params.row.bank_ifsc}
            </Typography>
          )
        ),
      },
      {
        headerName: "Paytm Phone",
        field: "paytm_phone",
        width: 150,
        renderCell: (params: GridCellParams) => (
          renderMaskedDetailValue(
            <Typography variant="body2">
              {params.row.paytm_phone == null ? "-" : params.row.paytm_phone}
            </Typography>
          )
        ),
      },
      {
        headerName: "UPI Key",
        field: "upi_key",
        width: 150,
        renderCell: (params: GridCellParams) => (
          renderMaskedDetailValue(
            <Typography variant="body2">
              {params.row.upi_key == null ? "-" : params.row.upi_key}
            </Typography>
          )
        ),
      },
      // {
      //     headerName: "Edit",
      //     field: "action",
      //     width: 80,
      //     renderCell: (params: GridCellParams) => (
      //         <IconButton type='button' size='small' sx={{ outline: 'none !important', width: '20px !important' }}><EditOutlined /></IconButton>
      //     )
      // }
    ];

    const pickupColumns: any = [
      {
        headerName: "Id",
        field: "id",
        width: 100,
      },
      {
        headerName: "Date",
        field: "pickup_date",
        width: 100,
      },
      {
        headerName: "Slot",
        field: "pickup_slot",
        width: 100,
      },
      {
        headerName: "Payment",
        field: "payment_status",
        width: 110,
      },
      {
        headerName: "Status",
        field: "pickup_status",
        width: 110,
        renderCell: (params: GridCellParams) => (
          <Typography
            className={
              params.row.pickup_status == "complete"
                ? "statusTextSuccess"
                : "statusTextError"
            }
            style={{ cursor: "pointer" }}
          >
            {params.row.pickup_status == "complete" ? "Complete" : "Pending"}
          </Typography>
        ),
      },
    ];

    const pausePickupColumns: any = [
      {
        headerName: "Id",
        field: "id",
        width: 80,
      },
      {
        headerName: "Start Date",
        field: "start_date",
        width: 95,
      },
      {
        headerName: "End Date",
        field: "end_date",
        width: 95,
      },
      {
        headerName: "Status",
        field: "is_active",
        width: 360,
        renderCell: (params: GridCellParams) => (
          <Typography>
            {params.row.is_active == 0
              ? "Pickups pause request cancelled."
              : "Pickups will be paused between selected dates."}
          </Typography>
        ),
      },
      {
        headerName: "Remarks",   
        field: "remarks",
        width: 250,
        renderCell: (params: GridCellParams) => (
          <Typography>
            {params.row.remarks ? params.row.remarks : "-"}
          </Typography>
        ),
      },
    ];

    const AlertsColumn: any = [
      {
        headerName: "Id",
        field: "id",
        width: 80,
        renderCell: (params: GridCellParams) => (
          <span style={{ cursor: "pointer" }}>{params.value}</span>
        ),
      },
      {
        headerName: "Mode",
        field: "mode",
        width: 80,
        renderCell: (params: GridCellParams) => (
          <span style={{ cursor: "pointer" }}>{params.value}</span>
        ),
      },
      {
        headerName: "Type",
        field: "type",
        width: 100,
        renderCell: (params: GridCellParams) => (
          <span style={{ cursor: "pointer" }}>{params.value}</span>
        ),
      },
      {
        headerName: "Content",
        field: "content",
        width: 300,
        renderCell: (params: GridCellParams) => (
          <span style={{ cursor: "pointer" }}>{params.value}</span>
        ),
      },
      {
        headerName: "Updated",
        field: "updated_at",
        width: 200,
        renderCell: (params: GridCellParams) => (
          <span style={{ cursor: "pointer" }}>{params.value}</span>
        ),
      },
    ];

    const handleDeleteBag = (bagId: any) => {
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        pickup_bag_id: bagId,
      };
      axios
        .post("unlinkPickupBag", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchPickupDetails();
          } else {
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleEditBag = () => {
      this.setState({ showLoader: true });
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        bag_type: this.state.bagDetails.bag_type,
        created_at: this.state.bagDetails.created_at,
        flag: this.state.bagDetails.flag,
        flag_image: this.state.bagDetails.flag_image,
        flag_images: null,
        id: this.state.bagDetails.id,
        pickup_bag_id: this.state.bagDetails.id,
        pickup_id: this.state.bagDetails.pickup_id,
        uid: this.state.bagDetails.uid,
        updated_at: this.state.bagDetails.updated_at,
        weight: this.state.bagDetails.weight,
      };
      // console.log("body",body);
      axios
        .post("editPickupBag", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showEditBag: false, showLoader: false });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchPickupDetails();
          } else {
            this.setState({ showEditBag: false, showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showEditBag: false, showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const currentDate = new Date();
    const thirtyDaysBeforeDate = new Date(currentDate.setDate(currentDate.getDate() - 30));
    const disabled = (this.state.pickup_details.pickup_status == "complete" || new Date(this.state.pickup_details.pickup_date) < thirtyDaysBeforeDate) ? true : false;
    let deleteTooltip = "Delete Bag";
    if (disabled) {
        if(this.state.pickup_details.pickup_status == "complete") {
            deleteTooltip = "Bags cannot be deleted for completed pickups";
        } else {
            deleteTooltip = "Bags cannot be deleted for pickups older than 30 days";
        }
    }

    const bagsColumn: any = [
      { headerName: "Id", field: "id", width: 80 },
      { headerName: "UID", field: "uid", width: 110 },
      { headerName: "Weight", field: "weight", width: 80 },
      { headerName: "Added", field: "created_at", width: 160 },
      {
        headerName: "Actions",
        field: "actions",
        type: "actions",
        getActions: (params: GridRowParams) => [
          // <GridActionsCellItem
          //   icon={<EditOutlined />}
          //   label="Edit Bag"
          //   onClick={() =>
          //     this.setState({ bagDetails: params.row, showEditBag: true })
          //   }
          // />,
          <GridActionsCellItem
            icon={
              <Tooltip title={deleteTooltip}>
                <DeleteOutlined color={disabled ? 'disabled' : 'error'}  />
              </Tooltip>
            }
            label="Delete Bag"
            onClick={() => !disabled && this.setState({ showDeleteBagConfirmation: true, bagToDelete: params.row.id })}
          />,
        ],
      },
    ];

    const handleAddBag = () => {
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        pickup_id: this.state.pickup_id,
        uid: this.state.bagUid,
        weight: this.state.bagWeight,
        forceSave: this.state.forceAddBag,
      };
      axios
        .post("addPickupBag", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            // console.log(response.data.data);
            // this.setState({ bagUid: '', bagWeight: '', showAddBag: false });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });

            /**Script to remove the bag from inventory starts here*/
            let body1 = { barcode: this.state.bagUid };
            axios
              .post("removeBarcode", body1, {
                headers: { "Content-Type": "application/json" },
              })
              .then((response1: any) => {
                if (response1.data.success) {
                  toast.success("Bag removed from inventory successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  });
                } else {
                  toast.error(
                    "Something went wrong while removing Bag from inventory!",
                    {
                      position: "top-right",
                      autoClose: 3000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "colored",
                    }
                  );
                }
              })
              .catch((error) => {
                toast.error(error.response.data.msg, {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                });
              });
            /**Script to remove the bag from inventory ends here*/

            this.setState({ bagUid: "", bagWeight: "", showAddBag: false });
            this.fetchPickupDetails();
          } else {
            // console.log("err");
            this.setState({ bagUid: "", bagWeight: "", showAddBag: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ bagUid: "", bagWeight: "", showAddBag: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const activeBags = this.state.availableBagsWithCustomers.filter(
      (row: any) => row.is_active
    );
    const deletedBags = this.state.availableBagsWithCustomers.filter(
      (row: any) => !row.is_active
    );
    const renderBagsTable = (rows: any[], allowSelection: boolean) => (
      <TableContainer component={Paper} sx={{ maxHeight: '100%', height: '100%'}}>
        <Table size="small" stickyHeader ref={this.bagsTableRef} tabIndex={0}>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                {allowSelection ? (
                  <Checkbox
                    indeterminate={
                      this.state.selectedBarcodes.length > 0 &&
                      this.state.selectedBarcodes.length < activeBags.length
                    }
                    checked={
                      activeBags.length > 0 &&
                      this.state.selectedBarcodes.length === activeBags.length
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        this.setState({
                          selectedBarcodes: activeBags,
                        });
                      } else {
                        this.setState({ selectedBarcodes: [] });
                      }
                    }}
                  />
                ) : (
                  <Checkbox disabled />
                )}
              </TableCell>
              <TableCell>Barcode</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Warehouse</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row: any) => (
              <TableRow
                key={row.id}
                selected={this.state.selectedBarcodes.some(
                  (b: any) => b.barcode === row.barcode
                )}
              >
                <TableCell padding="checkbox">
                  {allowSelection ? (
                    <Checkbox
                      checked={this.state.selectedBarcodes.some(
                        (b: any) => b.barcode === row.barcode
                      )}
                      onChange={(e) => {
                        if (e.target.checked) {
                          this.setState((prevState) => ({
                            selectedBarcodes: [
                              ...prevState.selectedBarcodes,
                              row,
                            ],
                          }));
                        } else {
                          this.setState((prevState) => ({
                            selectedBarcodes: prevState.selectedBarcodes.filter(
                              (b: any) => b.barcode !== row.barcode
                            ),
                          }));
                        }
                      }}
                      disabled={!row.is_active}
                    />
                  ) : (
                    <Checkbox disabled />
                  )}
                </TableCell>
                <TableCell>{row.barcode}</TableCell>
                <TableCell>{row.linked_date}</TableCell>
                <TableCell>{row.bag_type}</TableCell>
                <TableCell>
                  <Typography
                    className={
                      row.reached_warehouse
                        ? "statusTextSuccess"
                        : "statusTextError"
                    }
                    component="span"
                  >
                    {row.reached_warehouse ? "Yes" : "No"}
                  </Typography>
                </TableCell>
                <TableCell>
                  {allowSelection && row.is_active ? (
                    <IconButton
                      type="button"
                      color="error"
                      size="small"
                      onClick={() =>
                        this.setState({
                          showDeleteBarcodeConfirmationDialog: true,
                          barcodeToBeDeleted: row,
                        })
                      }
                    >
                      <DeleteOutlined />
                    </IconButton>
                  ) : (
                    <span>&nbsp;</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );

    return (
      <div>
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
          open={this.state.showLoader}
          // onClick={() => this.setState({ showLoader: false })}
        >
          <CircularProgress className="customLoader" />
        </Backdrop>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <NeighbourhoodHeader user={this.props.user} />
        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="mt-3">
            <Card>
              <CardHeader
                // avatar={
                //     <Button size="small" variant='outlined' className='customBackButton' component={Link} to={'/neighbourhood/customers'}><KeyboardArrowLeftRounded /></Button>
                // }
                avatar={
                  <Button
                    size="small"
                    variant="outlined"
                    className="customBackButton"
                    onClick={() => {
                      if (this.props.history.length > 1) {
                        this.props.history.goBack();
                      } else {
                        this.props.history.push("/neighbourhood/customers");
                      }
                    }}
                  >
                    <KeyboardArrowLeftRounded />
                  </Button>
                }
                title="Customer Details"
                className="text-left"
                action={
                  <IconButton
                    aria-label="customer-more-options-button"
                    sx={{ outline: "none !important" }}
                    onClick={(e: any) => handleCustomerMoreOptions(e)}
                  >
                    <MoreHorizOutlined
                      id="customer-more-options-button"
                      sx={{ outline: "none !important" }}
                    />
                    <Menu
                      id="customer-more-options-menu"
                      aria-labelledby="customer-more-options-button"
                      anchorEl={this.state.anchorEl}
                      open={open}
                      onClose={() => closeCustomerMoreOptions()}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      <MenuItem
                        className="customMenuItem"
                        onClick={() =>
                          handleEditCustomer(this.state.customer_details)
                        }
                      >
                        {t("Edit Customer Details")}
                      </MenuItem>
                      {/* <MenuItem className='customMenuItem' onClick={() => toggleCustomerStatus(this.state.customer_id, this.state.customer_details.status)}>{(this.state.customer_details.status == 'Active') ? 'Deactivate' : 'Activate'} {t("Customer")}</MenuItem> */}
                      {/* <MenuItem className='customMenuItem' onClick={() => { closeCustomerMoreOptions(); this.setState({ showDeleteDialog: true }) }}>{t("DeleteCustomer")}</MenuItem> */}
                    </Menu>
                  </IconButton>
                }
              />
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <Card
                      className="customCardDetails"
                      sx={{ minHeight: "320px" }}
                    >
                      <CardContent>
                        <Typography
                          variant="h6"
                          component="div"
                          className="mt-3 mb-3"
                        >
                          <b>{this.state.customer_details?.customer_name}</b>
                        </Typography>
                        <Button
                          type="button"
                          variant="contained"
                          className="balanceButton"
                        >
                          <AccountBalanceWalletOutlined />
                          &nbsp; Balance: {this.state.customer_details?.balance}
                        </Button>
                        <Divider className="mt-3 mb-3" />
                        <Grid container spacing={2}>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Customer Id
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {this.state.customer_details?.id}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Registration Status
                          </Grid>
                          <Grid
                            item
                            md={6}
                            xs={6}
                            className={
                              "detailsValue " +
                              (this.state.customer_details.status == "Active"
                                ? "statusTextSuccess"
                                : "statusTextError")
                            }
                          >
                            {this.state.customer_details?.status}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Pause Pickup Status
                          </Grid>
                          <Grid
                            item
                            md={6}
                            xs={6}
                            className={
                              "detailsValue " +
                              (this.state.customer_details
                                .pause_pickup_status == "Active"
                                ? "statusTextSuccess"
                                : "statusTextError")
                            }
                          >
                            {this.state.customer_details?.pause_pickup_status}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Bintix Joining Date
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {this.state.customer_details?.joining_date
                              ? new Date(
                                  this.state.customer_details.joining_date
                                )
                                  .toISOString()
                                  .split("T")[0]
                              : "NA"}
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Card
                      className="customCardDetails"
                      sx={{ minHeight: "196px" }}
                    >
                      <CardContent className="overview">
                        <Grid container spacing={2}>
                          <Grid item md={6} xs={8} className="detailsTitle">
                            <Typography
                              variant="subtitle1"
                              component="div"
                              className="overviewTitle"
                            >
                              Community Details
                            </Typography>
                          </Grid>
                          <Grid item md={6} xs={4} className="detailsValue">
                            {this.state.customer_details?.route_id && (
                              <Button
                                variant="contained"
                                color="error"
                                size="small"
                                sx={{ outline: "none !important" }}
                                onClick={() =>
                                  this.setState({
                                    showRemoveUserFromCommunityConfirmationDialog:
                                      true,
                                  })
                                }
                              >
                                Remove
                              </Button>
                            )}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Community Name
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.customer_details.route?.name
                            )}
                            {!this.state.customer_details.route_id && (
                              <Button
                                variant="contained"
                                size="small"
                                sx={{ outline: "none !important" }}
                                onClick={() =>
                                  this.setState({
                                    showAddUserToCommunityDialog: true,
                                  })
                                }
                              >
                                Add
                              </Button>
                            )}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            City Name
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.customer_details.city_name || "-"
                            )}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Joined
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.customer_details.route?.joined_at
                            )}
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                    <Card className="customCardDetails mt-4">
                      <CardContent className="overview">
                        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} className="detailsTitle">
                            <Typography
                              variant="subtitle1"
                              component="div"
                              className="overviewTitle"
                            >
                              Payment Details
                            </Typography>
                          </Grid>
                          {/* <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Billing Amount
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.customer_details?.billing_amount}
                                                    </Grid> */}
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Current Balance
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.customer_details?.balance
                            )}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Historic Earnings
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.ecoStatData?.price?.toFixed()
                            )}
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Card
                      className="customCardDetails"
                      sx={{ minHeight: "366px" }}
                    >
                      <CardContent className="overview">
                        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} className="detailsTitle">
                            <Typography
                              variant="subtitle1"
                              component="div"
                              className="overviewTitle"
                            >
                              Contact Details
                            </Typography>
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Full Name
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.customer_details?.customer_name
                            )}
                          </Grid>
                          {/* <Grid item md={4} xs={4} className='detailsTitle'>
                                                        Address
                                                    </Grid>
                                                    <Grid item md={8} xs={8} className='detailsValue'>
                                                        {this.state.customer_details?.address}
                                                    </Grid> */}
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Phone
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.customer_details?.mobile
                            )}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Email
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.customer_details?.email
                            )}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            House No.
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.customer_details?.address
                            )}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            About
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.customer_details &&
                              this.state.customer_details.about
                                ? this.state.customer_details.about
                                : "NA"
                            )}
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsTitle">
                            Referral Code
                          </Grid>
                          <Grid item md={6} xs={6} className="detailsValue">
                            {renderMaskedDetailValue(
                              this.state.customer_details &&
                              this.state.customer_details.referral_code
                                ? this.state.customer_details.referral_code
                                : "NA"
                            )}
                          </Grid>
                          <Grid item xs={12} style={{ marginTop: 8 }}>
                            <Stack
                              direction="row"
                              spacing={2}
                              justifyContent="center"
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() =>
                                  this.setState(
                                    { showHistoryPopup: true },
                                    () => this.fetchCommunityHistory()
                                  )
                                }
                              >
                                History
                              </Button>
                              <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() =>
                                  this.setState({ showNotesPopup: true }, () =>
                                    this.fetchNotes()
                                  )
                                }
                              >
                                Notes
                              </Button>
                            </Stack>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          {/* Pickups Card */}
          <Grid item md={6} xs={12} className="mt-3">
            <Card>
              <CardHeader
                title={
                  <>
                    <Grid container spacing={2}>
                      <Grid item md={9} xs={12}>
                        <Typography
                          variant="h5"
                          className="MuiCardHeader-title"
                          sx={{ lineHeight: "40px" }}
                        >
                          {t("Pickups")}
                        </Typography>
                      </Grid>

                      <Grid item md={3} xs={12} className="text-right">
                        <FormControl fullWidth={true} size="small">
                          <InputLabel id="demo-simple-select-label">
                            Type
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={this.state.pickupFilter}
                            label="Age"
                            onChange={(e: any) =>
                              this.setState(
                                { pickupFilter: e.target.value },
                                () => this.fetchCustomerPickups()
                              )
                            }
                          >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="pending">Pending</MenuItem>
                            <MenuItem value="complete">Complete</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </>
                }
                className="text-left"
              />
              <CardContent>
                <div style={{ height: "648px", width: "100%" }}>
                  <DataGrid
                    aria-label="Pickups"
                    columns={pickupColumns}
                    rows={this.state.customerPickups}
                    rowCount={this.state.pickupRowCount}
                    pageSize={this.state.pageSize}
                    onPageChange={(page) => this.fetchCustomerPickups(page)}
                    onPageSizeChange={(newPageSize) =>
                      this.setState({ pageSize: newPageSize }, () =>
                        this.fetchCustomerPickups(0, newPageSize)
                      )
                    }
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    paginationMode="server"
                    disableVirtualization
                    className="clickableList"
                    // onRowClick={(params: GridRowParams) => {
                    //     this.props.history.push('/operations/batch-pickups/group-pickups/pickup-details/' + params.id);
                    // }}
                    onRowClick={this.handleRowClick}
                    components={{
                      MoreActionsIcon: EditOutlined,
                    }}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6} xs={12} className="mt-3">
            <Card>
              <CardHeader
                title={
                  <Typography
                    variant="h5"
                    className="MuiCardHeader-title"
                    sx={{ lineHeight: "40px" }}
                  >
                    {t("Available Bags")}
                  </Typography>
                }
                className="text-left"
                action={
                  <Stack direction="row" spacing={1}>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ outline: "none !important", width: "auto" }}
                      onClick={() =>
                        this.setState({ showAddBarcodeSetModal: true })
                      }
                    >
                      <Add /> Add Set
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ outline: "none !important", width: "auto" }}
                      onClick={() => this.setState({ showAvailableBags: true })}
                    >
                      <Add /> Add Bag
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      sx={{ outline: "none !important", width: "auto" }}
                      onClick={this.handleDeleteSelectedBags}
                      disabled={this.state.selectedBarcodes.length === 0}
                    >
                      Delete Bags
                    </Button>
                  </Stack>
                  /*<Box sx={{ display: 'flex', gap: 2 }}>
                                    <Button variant="contained" size="small" sx={{ outline: 'none !important', width: 'auto'  }} onClick={() => this.setState({ showAddBarcodeSetModal: true })}>
                                        <Add /> Add Set
                                    </Button>
                                    <Button variant="contained" size="small" sx={{ outline: 'none !important', width: 'auto'  }} onClick={() => this.setState({ showAvailableBags: true })}>
                                        <Add /> Add Bag
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        size="small"
                                        sx={{ outline: 'none !important', width: 'auto'  }}
                                        onClick={this.handleDeleteSelectedBags}
                                        disabled={this.state.selectedBarcodes.length === 0}
                                    >
                                        Delete Bags
                                    </Button>
                                    </Box>*/
                }
              />
              <CardContent>
                {/* <DataGrid
                                     aria-label="Available Bags with Users"
                                     columns={bagsWithUserColumn}
                                     rows={this.state.availableBagsWithCustomers}
                                     rowCount={this.state.availableBagsWithCustomers.length} 
                                     pageSize={this.state.availableBagsWithUsersPageSize || 10} 
                                     rowsPerPageOptions={[10, 20, 50, 100]} 
                                     pagination
                                    //  paginationMode="server" 
                                     disableVirtualization
                                     onPageSizeChange={(newPageSize) => 
                                       this.setState({ availableBagsWithUsersPageSize: newPageSize }) 
                                     }
                                     sx={{
                                       height: '646px', 
                                       overflowY: 'auto', 
                                     }}
                                     components={{
                                       MoreActionsIcon: EditOutlined,
                                     }}
                                     getRowClassName={(params) =>
                                       !params.row.is_active ? "bg-gray" : ""
                                     }
                                     disableSelectionOnClick
                                     isRowSelectable={(params: GridRowParams) => (params.row.is_active) ? true : false }
                                     onSelectionModelChange={(ids) => {
                                        console.log("selected ids",ids);
                                        const selectedIDs = new Set(ids);
                                        const selectedBarcodes = this.state.availableBagsWithCustomers.filter((row: any) =>
                                            selectedIDs.has(row.id)
                                        );
                                        this.setState({ selectedBarcodes: selectedBarcodes })
                                    }}
                                    checkboxSelection
                                   /> */}
                {/* Previous single-table view kept for reference. */}
                {/* <TableContainer component={Paper} sx={{ maxHeight: 646 }}>
                  <Table
                    size="small"
                    stickyHeader
                    ref={this.bagsTableRef}
                    tabIndex={0}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            indeterminate={
                              this.state.selectedBarcodes.length > 0 &&
                              this.state.selectedBarcodes.length <
                                this.state.availableBagsWithCustomers.length
                            }
                            checked={
                              this.state.availableBagsWithCustomers.length >
                                0 &&
                              this.state.selectedBarcodes.length ===
                                this.state.availableBagsWithCustomers.length
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                this.setState({
                                  selectedBarcodes:
                                    this.state.availableBagsWithCustomers.filter(
                                      (row: any) => row.is_active
                                    ),
                                });
                              } else {
                                this.setState({ selectedBarcodes: [] });
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell>Barcode</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Warehouse</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.availableBagsWithCustomers.map((row: any) => (
                        <TableRow
                          key={row.id}
                          selected={this.state.selectedBarcodes.some(
                            (b: any) => b.barcode === row.barcode
                          )}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={this.state.selectedBarcodes.some(
                                (b: any) => b.barcode === row.barcode
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  this.setState((prevState) => ({
                                    selectedBarcodes: [
                                      ...prevState.selectedBarcodes,
                                      row,
                                    ],
                                  }));
                                } else {
                                  this.setState((prevState) => ({
                                    selectedBarcodes:
                                      prevState.selectedBarcodes.filter(
                                        (b: any) => b.barcode !== row.barcode
                                      ),
                                  }));
                                }
                              }}
                              disabled={!row.is_active}
                            />
                          </TableCell>
                          <TableCell>{row.barcode}</TableCell>
                          <TableCell>{row.linked_date}</TableCell>
                          <TableCell>{row.bag_type}</TableCell>
                          <TableCell>
                            <Typography
                              className={
                                row.reached_warehouse
                                  ? "statusTextSuccess"
                                  : "statusTextError"
                              }
                              component="span"
                            >
                              {row.reached_warehouse ? "Yes" : "No"}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            {row.is_active ? (
                              <IconButton
                                type="button"
                                color="error"
                                size="small"
                                onClick={() =>
                                  this.setState({
                                    showDeleteBarcodeConfirmationDialog: true,
                                    barcodeToBeDeleted: row,
                                  })
                                }
                              >
                                <DeleteOutlined />
                              </IconButton>
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer> */}
                <Box sx={{ height: '648px', display: 'flex', flexDirection: 'column' }}>
                <Accordion  expanded={this.state.deletedBagsOpen} onChange={(_, expanded) =>this.setState({ deletedBagsOpen: expanded })}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography>Deleted Bags ({deletedBags.length})</Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ height: deletedHeight, p: 0 }}>
                     <Box sx={{ height: '100%', overflow: 'auto' }}>
                    {renderBagsTable(deletedBags, false)}
                    </Box>
                  </AccordionDetails>
                </Accordion>
                <Accordion expanded={this.state.activeBagsOpen} onChange={(_, expanded) =>this.setState({ activeBagsOpen: expanded })} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography>Active Bags ({activeBags.length})</Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ height: activeHeight, p: 0 }}>
                    <Box sx={{ height: '100%', overflow: 'auto' }}>
                    {renderBagsTable(activeBags, true)}
                    </Box>
                  </AccordionDetails>
                </Accordion>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="mt-3">
            <Card>
              <CardHeader title="Assigned QR Codes" className="text-left" />
              <CardContent>
                <Grid container spacing={2}>
                  {this.state.qrCodeData?.map((item: any) => (
                    <Grid item md={3} xs={12}>
                      <img
                        src={`https://qrgen.bintix.com/api/generate_qr?content=${item.qrcode}&size=180&sharpness=2.0`}
                        alt={item.qrcode}
                        loading="lazy"
                      />
                      <Typography>{item.qrcode}</Typography>
                      <Typography
                        className={
                          item.is_active == 1
                            ? "statusTextSuccess"
                            : "statusTextError"
                        }
                      >
                        {item.is_active == 1 ? "Active" : "Inactive"}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="mt-3">
            <Card>
              <CardHeader title={t("Eco Stats")} sx={{ textAlign: "left" }} />
              <CardContent>
                <Grid container spacing={2} className="mt-2 mb-4">
                  <Grid item md={2.4} xs={12} className="text-center">
                    <Card sx={{ justifyContent: "center", display: "flex" }}>
                      <CardContent>
                        <Co2 sx={{ width: 56, height: 56, color: "#204d36" }} />
                        <Typography variant="h5" component="div">
                          {"~"} {this.state.ecoStatData?.co2?.toFixed(2)} {"kg"}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "12px", marginTop: "10px" }}
                        >
                          CO<sub>2</sub> eq {t("Averted")}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={2.4} xs={12} className="text-center">
                    <Card sx={{ justifyContent: "center", display: "flex" }}>
                      <CardContent>
                        <Forest
                          sx={{ width: 56, height: 56, color: "#204d36" }}
                        />
                        <Typography variant="h5" component="div">
                          {"~"} {this.state.ecoStatData?.trees?.toFixed(2)}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "12px", marginTop: "10px" }}
                        >
                          {t("Trees Saved")}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={2.4} xs={12} className="text-center">
                    <Card sx={{ justifyContent: "center", display: "flex" }}>
                      <CardContent>
                        <LocalGasStationOutlined
                          sx={{ width: 56, height: 56, color: "#204d36" }}
                        />
                        <Typography variant="h5" component="div">
                          {"~"} {this.state.ecoStatData?.oil?.toFixed(2)} {"L"}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "12px", marginTop: "10px" }}
                        >
                          {t("Fuel Saved")}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={2.4} xs={12} className="text-center">
                    <Card sx={{ justifyContent: "center", display: "flex" }}>
                      <CardContent>
                        <PaymentsOutlined
                          sx={{ width: 56, height: 56, color: "#204d36" }}
                        />
                        <Typography variant="h5" component="div">
                           {this.state.ecoStatData?.price?.toFixed(2)}{" "}
                          {"₹"}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "12px", marginTop: "10px" }}
                        >
                          {t("Earnings")}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={2.4} xs={12} className="text-center">
                    <Card sx={{ justifyContent: "center", display: "flex" }}>
                      <CardContent>
                        <DeleteOutline
                          sx={{ width: 56, height: 56, color: "#204d36" }}
                        />
                        <Typography variant="h5" component="div">
                          {" "}
                          {Math.floor(
                            this.state.ecoStatData?.total_kg?.toFixed(2)
                          )}{" "}
                          {"kg"}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "12px", marginTop: "10px" }}
                        >
                          {t("Total Kgs")}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item md={6} xs={12} className="mt-3">
            <Card>
              <CardHeader
                title={
                  <Typography
                    variant="h5"
                    className="MuiCardHeader-title"
                    sx={{ lineHeight: "40px" }}
                  >
                    {t("Pause Pickups")}
                  </Typography>
                }
                 action={
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<Add />}
                    onClick={() => this.setState({ showPauseModal: true })}
                    sx={{ outline: "none !important", width: "auto", mt: 1.3, mr: 1.3 }}
                  >
                    New Request
                  </Button>
                }
                className="text-left"
                // action={
                //     <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddPickup: true })}>
                //         <Add /> Add Pickup
                //     </Button>
                // }
              />
              <CardContent>
                {/* <DataGrid
                                    aria-label="Pause Pickups"
                                    columns={pausePickupColumns}
                                    rows={this.state.pausePickupData}
                                    disableVirtualization
                                // pageSize={this.state.pageSize}
                                // onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                // rowsPerPageOptions={[10, 20, 50, 100]}
                                // autoHeight={true}
                                // components={{
                                //     MoreActionsIcon: EditOutlined,
                                // }}
                                /> */}

                <DataGrid
                  aria-label="Pause Pickups"
                  columns={pausePickupColumns}
                  rows={this.state.pausePickupData}
                  rowCount={this.state.pausePickupData.length} // Make sure to set rowCount for pagination
                  pageSize={this.state.pageSize || 5} // Use the state value for pageSize, defaulting to 5
                  rowsPerPageOptions={[5, 10, 20, 50, 100]} // Dropdown for page size selection
                  pagination
                  paginationMode="server" // Enable server-side pagination if you fetch data from a server
                  onPageSizeChange={(newPageSize) =>
                    this.setState({ pageSize: newPageSize })
                  }
                  sx={{
                    height: "400px", // Enough to display 5 rows without scrolling
                    overflowY: "auto", // Enable vertical scrolling if rows exceed the visible height
                  }}
                  autoHeight={false} // Keep height fixed for consistent appearance
                  components={{
                    MoreActionsIcon: EditOutlined,
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6} xs={12} className="mt-3">
            <Card>
              <CardHeader
                title={
                  <Typography
                    variant="h5"
                    className="MuiCardHeader-title"
                    sx={{ lineHeight: "40px" }}
                  >
                    Transactions
                  </Typography>
                }
                className="text-left"
              />
              <CardContent>
                {/* <DataGrid
                             aria-label="Transactions"
                             columns={transactionColumns}
                             rows={this.state.transactions}
                             rowCount={this.state.transactionRowCount}
                             pageSize={this.state.transactionsPageSize}
                             disableVirtualization // Ensures consistent row rendering
                             rowHeight={50} // Matches row height with Pause Pickups
                             rowsPerPageOptions={[10, 20, 50, 100]} // Matches the same page size options
                             onPageChange={(page) => this.fetchCustomerWalletTransactions(page)}
                             onPageSizeChange={(newPageSize) => this.setState({ transactionsPageSize: newPageSize }, () => this.fetchCustomerWalletTransactions(0, newPageSize))}
                             paginationMode="server"
                             components={{
                                 MoreActionsIcon: EditOutlined,
                             }}
                             onRowClick={(params: GridRowParams) => {
                                 this.setState({ 
                                     showTransactionDetails: this.props.user.email === "reshma_m@bintix.com", "vijay@bintix.com",
                                     transactionDetails: params.row 
                                 });
                             }}
                         /> */}

                <DataGrid
                  aria-label="Transactions"
                  columns={transactionColumns}
                  rows={this.state.transactions}
                  rowCount={this.state.transactionRowCount}
                  pageSize={this.state.transactionsPageSize || 5} // Default visibility for 5 rows or selected size
                  rowsPerPageOptions={[5, 10, 20, 50, 100]} // Dropdown for selecting page size
                  disableVirtualization
                  rowHeight={50} // Ensure consistent row height
                  onPageChange={(page) =>
                    this.fetchCustomerWalletTransactions(
                      page,
                      this.state.transactionsPageSize
                    )
                  }
                  onPageSizeChange={(newPageSize) => {
                    this.setState({ transactionsPageSize: newPageSize }, () => {
                      // Fetch data for the first page with the new page size
                      this.fetchCustomerWalletTransactions(0, newPageSize);
                    });
                  }}
                  pagination
                  sx={{
                    height: 400, // Set height based on row count
                    overflowY:
                      this.state.transactions.length > 5 ? "auto" : "hidden", // Enable vertical scrolling only if more than 5 rows
                  }}
                  paginationMode="server"
                  components={{
                    MoreActionsIcon: EditOutlined,
                  }}
                  onRowClick={(params: GridRowParams) => {
                    this.setState({
                      showTransactionDetails: [
                        "reshma_m@bintix.com",
                        "vijay@bintix.com",
                        "kedarnath@bintix.com",
                      ].includes(this.props.user.email),
                      transactionDetails: params.row,
                    });
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item md={6} xs={12} className="mt-3">
            <Card>
              <CardHeader
                title={
                  <Typography variant="h5" sx={{ lineHeight: "40px" }}>
                    Payments
                  </Typography>
                }
                className="text-left"
                action={
                  [
                    "vijay@bintix.com",
                    "kedarnath@bintix.com",
                    "satheesh@bintix.com",
                  ].includes(this.props.user.email) && (
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ outline: "none !important" }}
                      onClick={() =>
                        this.setState({ showAddTransaction: true })
                      }
                    >
                      <Add /> Add
                    </Button>
                  )
                }
              />
              <CardContent>
                <DataGrid
                  aria-label="Payments"
                  columns={paymentColumns}
                  rows={this.state.payments}
                  rowCount={this.state.paymentRowCount}
                  pageSize={this.state.paymentsPageSize || 5} // Set default page size to 5 if not defined
                  paginationMode="server" // Enable server-side pagination
                  disableVirtualization // Ensure all rows on the page are rendered
                  onPageChange={(page) =>
                    this.fetchCustomerWalletPayments(page)
                  } // Fetch data on page change
                  onPageSizeChange={(newPageSize) => {
                    this.setState({ paymentsPageSize: newPageSize }, () => {
                      this.fetchCustomerWalletPayments(0, newPageSize); // Reset page to 0 on page size change
                    });
                  }}
                  rowsPerPageOptions={[5, 10, 20, 50, 100]} // Dropdown for selecting page size
                  sx={{
                    height: "400px", // Set fixed height to 400px
                    overflowY:
                      this.state.paymentsPageSize > 5 ? "auto" : "hidden", // Enable vertical scrolling if page size exceeds 5
                  }}
                  autoHeight={false} // Keep height fixed
                  className="clickableList"
                  components={{
                    MoreActionsIcon: EditOutlined,
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6} xs={12} className="mt-3">
            <Card>
              <CardHeader
                title={
                  <Typography variant="h5" sx={{ lineHeight: "40px" }}>
                    Tickets
                  </Typography>
                }
                className="text-left"
                action={
                  <FormControl fullWidth size="small" sx={{ minWidth: 160 }}>
                    <InputLabel id="customer-tickets-type-label">
                      {t("Type")}
                    </InputLabel>
                    <Select
                      labelId="customer-tickets-type-label"
                      value={this.state.customerTicketsType}
                      onChange={(e: any) =>
                        this.setState(
                          { customerTicketsType: e.target.value },
                          () => this.fetchCustomerTickets()
                        )
                      }
                      displayEmpty
                      label={t("Type")}
                    >
                      <MenuItem key={"all"} value={"all"}>
                        {t("All")}
                      </MenuItem>
                      <MenuItem key={"Weight"} value={"weight"}>
                        {t("Weight")}
                      </MenuItem>
                      <MenuItem key={"Payment"} value={"payment"}>
                        {t("Payments")}
                      </MenuItem>
                      <MenuItem key={"MissedPickup"} value={"missed pickup"}>
                        {t("Missed Pickup")}
                      </MenuItem>
                      <MenuItem key={"MissedBag"} value={"missed bag"}>
                        {t("Missed Bag")}
                      </MenuItem>
                      <MenuItem key={"AccountIssue"} value={"account issue"}>
                        {t("Account Issue")}
                      </MenuItem>
                      <MenuItem key={"AgentIssue"} value={"agent issue"}>
                        {t("Agent Issue")}
                      </MenuItem>
                      <MenuItem
                        key={"PurchaseNewBag"}
                        value={"purchase new bags"}
                      >
                        {t("Purchase new bag")}
                      </MenuItem>
                      <MenuItem
                        key={"RegularBagRequest"}
                        value={"regular bag request"}
                      >
                        {t("Regular Bag Request")}
                      </MenuItem>
                      <MenuItem key={"Other"} value={"other"}>
                        {t("Other")}
                      </MenuItem>
                    </Select>
                  </FormControl>
                }
              />
              <CardContent>
                <DataGrid
                  aria-label="Customer Tickets"
                  columns={[
                    { headerName: "Id", field: "id", width: 80 },
                    {
                      headerName: "Community Name",
                      field: "community",
                      width: 160,
                      valueGetter: (params: any) =>
                        params.row?.user?.community?.info?.name || "-",
                    },
                    { headerName: "Type", field: "type", width: 120 },
                    {
                      headerName: "Status",
                      field: "status",
                      width: 120,
                      renderCell: (params: any) => (
                        <Typography
                          sx={{ fontWeight: "bold" }}
                          className={
                            params.row.status === "closed"
                              ? "statusTextSuccess"
                              : params.row.status === "inProgress"
                              ? "statusTextWarning"
                              : params.row.status === "responded"
                              ? "statusTextInfo"
                              : "statusTextError"
                          }
                        >
                          {params.row.status === "closed"
                            ? "Closed"
                            : params.row.status === "inProgress"
                            ? "In Progress"
                            : params.row.status === "responded"
                            ? "Responded"
                            : "Open"}
                        </Typography>
                      ),
                    },
                    {
                      headerName: "Query",
                      field: "ticket_query",
                      width: 220,
                      sortable: false,
                      valueGetter: (params: any) =>
                        params.row?.ticket_query?.message || "-",
                      renderCell: (params: GridCellParams) =>
                        renderMaskedDetailValue(params.value),
                    },
                    {
                      headerName: "Created At",
                      field: "created_at",
                      width: 150,
                    },
                  ]}
                  rows={this.state.customerTickets}
                  rowCount={this.state.customerTicketsRowCount}
                  pageSize={this.state.customerTicketsPageSize || 5}
                  paginationMode="server"
                  disableVirtualization
                  onPageChange={(page) =>
                    this.fetchCustomerTickets(page)
                  }
                  onPageSizeChange={(newPageSize) => {
                    this.setState(
                      { customerTicketsPageSize: newPageSize },
                      () => {
                        this.fetchCustomerTickets(0, newPageSize);
                      }
                    );
                  }}
                  rowsPerPageOptions={[5, 10, 20, 50, 100]}
                  sx={{
                    height: "400px",
                    overflowY:
                      this.state.customerTicketsPageSize > 5
                        ? "auto"
                        : "hidden",
                    "& .MuiDataGrid-row": {
                      cursor: "pointer",
                    },
                  }}
                  autoHeight={false}
                  onRowClick={(params: GridRowParams) => {
                    window.open(`/neighbourhood/tickets/${params.id}`, "_blank");
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
          {/* <Grid item md={6} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={<>
                                    <Grid container spacing={2}>
                                        <Grid item md={6} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Alerts")}</Typography>
                                        </Grid>

                                        <Grid item md={6} xs={12}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel id="demo-simple-select-label">Type</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={this.state.alertsMode}
                                                    label="Age"
                                                    onChange={(e: any) => this.setState({ alertsMode: e.target.value }, () => this.fetchNotifications())}
                                                >
                                                    <MenuItem value=''>All</MenuItem>
                                                    <MenuItem value='SMS'>SMS</MenuItem>
                                                    <MenuItem value='email'>E-Mail</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </>
                                }
                                className="text-left"

                            />
                            <CardContent>
                                 <DataGrid
                                   aria-label="Alerts"
                                   columns={AlertsColumn}
                                   rows={this.state.alertsData}
                                   pageSize={this.state.pageSize || 5} // Default page size is 5 if not defined
                                   paginationMode="client" // Client-side pagination
                                   disableVirtualization // Ensure all rows on the page are rendered
                                   onRowClick={(params: GridRowParams) => {
                                     this.setState({
                                       showAlerts: true,
                                       alertBody: params.row.content,
                                       alertResponse: params.row.response,
                                     });
                                   }}
                                   onPageSizeChange={(newPageSize) => {
                                     this.setState({ pageSize: newPageSize }); // Update page size dynamically
                                   }}
                                   rowsPerPageOptions={[5, 10, 20, 50, 100]} // Dropdown for page size options
                                   sx={{
                                     height: '400px', // Fixed height of 400px
                                     overflowY: this.state.pageSize > 5 ? 'auto' : 'hidden', // Enable vertical scrolling if the page size exceeds 5
                                   }}
                                   autoHeight={false} // Keep the height fixed at 400px
                                   components={{
                                     MoreActionsIcon: EditOutlined,
                                   }}
                                 />         
                        </CardContent>
                        </Card>
                    </Grid> */}
        </Grid>
        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="mt-3">
            <Card>
              <CardHeader
                title="Beneficiaries"
                className="text-left"
                // action={
                //     <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddTransaction: true })}>
                //         <Add /> Add Bag
                //     </Button>
                // }
              />
              <CardContent>
                {/* <DataGrid
                                    aria-label="Beneficiaries"
                                    columns={beneficiaries_columns}
                                    rows={this.state.beneficiaries_data}
                                    disableVirtualization
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                /> */}

                <DataGrid
                  aria-label="Beneficiaries"
                  columns={beneficiaries_columns}
                  rows={this.state.beneficiaries_data}
                  pageSize={this.state.pageSize || 5}
                  disableVirtualization={true}
                  onPageSizeChange={(newPageSize) => {
                    this.setState({ pageSize: newPageSize });
                  }}
                  rowsPerPageOptions={[5, 10, 20, 50, 100]}
                  sx={{
                    height: "400px",
                    overflowY: this.state.pageSize > 5 ? "auto" : "hidden",
                  }}
                  autoHeight={false}
                  components={{
                    MoreActionsIcon: EditOutlined,
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Modal
          open={this.state.showAddTransaction}
          onClose={() => this.setState({ showAddTransaction: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="Add Transaction"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showAddTransaction: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="type-label">Type *</InputLabel>
                      <Select
                        labelId="type-label"
                        value={this.state.transaction_type}
                        onChange={(e) =>
                          this.setState({ transaction_type: e.target.value })
                        }
                        displayEmpty
                        label="Type *"
                        fullWidth={true}
                      >
                        <MenuItem key={1} value={"credit"}>
                          Credit
                        </MenuItem>
                        <MenuItem key={2} value={"debit"}>
                          Debit
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="amount-input"
                      label="Amount *"
                      type={"number"}
                      InputProps={{
                        inputProps: { min: 0 },
                      }}
                      value={this.state.transaction_amount}
                      onChange={(e: any) =>
                        this.setState({ transaction_amount: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="transaction-comment-input"
                      label="Comment"
                      value={this.state.transaction_comment}
                      onChange={(e: any) =>
                        this.setState({ transaction_comment: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showAddTransaction: false })}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() => handleAddTransaction()}
                >
                  Add Transaction
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAddPickup}
          onClose={() => this.setState({ showAddPickup: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="Add Pickup"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showAddPickup: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DateTimePicker
                          renderInput={(props) => <TextField {...props} />}
                          label="Date Time *"
                          value={this.state.pickup_date}
                          onChange={(newValue: any) => {
                            this.setState({ pickup_date: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="zone-label">Zone *</InputLabel>
                      <Select
                        labelId="zone-label"
                        value={this.state.pickup_zone}
                        onChange={(e) =>
                          this.setState({ pickup_zone: e.target.value })
                        }
                        displayEmpty
                        label="Zone *"
                        fullWidth={true}
                      >
                        <MenuItem key={1} value={"Zone 1"}>
                          Zone 1
                        </MenuItem>
                        <MenuItem key={2} value={"Zone 2"}>
                          Zone 2
                        </MenuItem>
                        <MenuItem key={3} value={"Zone 3"}>
                          Zone 3
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <Typography variant="subtitle1" component="div">
                      Select Slot *
                    </Typography>
                    <ButtonGroup
                      variant="contained"
                      className="diversionButtonGroup"
                      aria-label="Slots button group"
                      fullWidth={true}
                    >
                      <Button
                        className={
                          this.state.pickup_slot == "08:00AM - 10:00AM"
                            ? "active"
                            : ""
                        }
                        onClick={() =>
                          this.setState({ pickup_slot: "08:00AM - 10:00AM" })
                        }
                      >
                        08:00AM - 10:00AM
                      </Button>
                      <Button
                        className={
                          this.state.pickup_slot == "10:00AM - 12:00PM"
                            ? "active"
                            : ""
                        }
                        onClick={() =>
                          this.setState({ pickup_slot: "10:00AM - 12:00PM" })
                        }
                      >
                        10:00AM - 12:00PM
                      </Button>
                      <Button
                        className={
                          this.state.pickup_slot == "12:00PM - 02:00PM"
                            ? "active"
                            : ""
                        }
                        onClick={() =>
                          this.setState({ pickup_slot: "12:00PM - 02:00PM" })
                        }
                      >
                        12:00PM - 02:00PM
                      </Button>
                      <Button
                        className={
                          this.state.pickup_slot == "02:00PM - 04:00PM"
                            ? "active"
                            : ""
                        }
                        onClick={() =>
                          this.setState({ pickup_slot: "02:00PM - 04:00PM" })
                        }
                      >
                        02:00PM - 04:00PM
                      </Button>
                    </ButtonGroup>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showAddPickup: false })}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() => handleAddPickup()}
                >
                  Add Pickup
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showEditCustomer}
          onClose={() => this.setState({ showEditCustomer: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={
                  t("Edit Customer") +
                  (this.state.customerEditDetails?.customer_name
                    ? " of " + this.state.customerEditDetails?.customer_name
                    : "")
                }
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showEditCustomer: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="customer-name-input"
                      label={t("Customer Name") + " *"}
                      value={this.state.customerEditDetails?.customer_name}
                      onChange={(e: any) =>
                        this.setState({
                          customerEditDetails: {
                            ...this.state.customerEditDetails,
                            customer_name: e.target.value,
                          },
                        })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="mobile-input"
                      label={t("Mobile") + " *"}
                      value={this.state.customerEditDetails?.mobile}
                      onChange={(e: any) =>
                        this.setState({
                          customerEditDetails: {
                            ...this.state.customerEditDetails,
                            mobile: e.target.value,
                          },
                        })
                      }
                      fullWidth={true}
                      disabled={
                        ![
                          "vijay@bintix.com",
                          "kedarnath@bintix.com",
                          "satheesh@bintix.com",
                        ].includes(this.props.user.email)
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="email-input"
                      label={t("Email") + " *"}
                      type={"email"}
                      value={this.state.customerEditDetails?.email}
                      onChange={(e: any) =>
                        this.setState({
                          customerEditDetails: {
                            ...this.state.customerEditDetails,
                            email: e.target.value,
                          },
                        })
                      }
                      fullWidth={true}
                      disabled={
                        ![
                          "vijay@bintix.com",
                          "kedarnath@bintix.com",
                          "satheesh@bintix.com",
                        ].includes(this.props.user.email)
                      }
                    />
                  </Grid>
                  {/* <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">{t("City")} *</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.customerEditDetails?.city_id}
                                                onChange={(e) => handleHierarchyChange(e.target.value)}
                                                displayEmpty
                                                label={t("City") + " *"}
                                                fullWidth={true}
                                            >
                                                {this.props.user.selectedHierarchies.map(
                                                    (city: any, key: number) => {
                                                        return (
                                                            <MenuItem key={key} value={city.id}>
                                                                {city.name}
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}
                                            </Select>
                                        </FormControl>
                                    </Grid> */}
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="customer-address-input"
                      label={t("House No.") + " *"}
                      value={this.state.customerEditDetails?.customer_address}
                      onChange={(e: any) =>
                        this.setState({
                          customerEditDetails: {
                            ...this.state.customerEditDetails,
                            customer_address: e.target.value,
                          },
                        })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  {/* <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="routes-select-label">
                                                {t("Route")} *
                                            </InputLabel>
                                            <Select
                                                labelId="routes-select-label"
                                                value={this.state.customerEditDetails?.route_id}
                                                onChange={(e) =>
                                                    this.setState({ customerEditDetails: { ...this.state.customerEditDetails, route_id: e.target.value } })
                                                }
                                                displayEmpty
                                                label={t("Route") + " *"}
                                                fullWidth={true}
                                            >
                                                {this.state.routes.map((route: any) => {
                                                    return (
                                                        <MenuItem key={route.id} value={route.id}>
                                                            {route.name}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Grid> */}
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="customer-about-input"
                      label={t("About")}
                      value={this.state.customerEditDetails?.about}
                      onChange={(e: any) =>
                        this.setState({
                          customerEditDetails: {
                            ...this.state.customerEditDetails,
                            about: e.target.value,
                          },
                        })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="customer-referral_code-input"
                      label={t("Referral Code")}
                      value={this.state.customerEditDetails?.referral_code}
                      onChange={(e: any) =>
                        this.setState({
                          customerEditDetails: {
                            ...this.state.customerEditDetails,
                            referral_code: e.target.value,
                          },
                        })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showEditCustomer: false })}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() => handleUpdateCustomer()}
                >
                  {t("Update Customer")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAlerts}
          onClose={() => this.setState({ showAlerts: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={t("Alerts Body")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showAlerts: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Typography className="m-2">{this.state.alertBody}</Typography>
                <Divider />
                <Typography className="m-2">
                  {this.state.alertResponse}
                </Typography>
                <Divider />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showAlerts: false })}
                >
                  {t("Close")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAvailableBags}
          onClose={() => this.setState({ showAvailableBags: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={t("Alerts Body")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showAvailableBags: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="amount-input"
                      label="Barcode *"
                      type={"text"}
                      InputProps={{
                        inputProps: { min: 0 },
                      }}
                      value={this.state.barcode}
                      onChange={(e: any) =>
                        this.setState({ barcode: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="type-label">Bag Type *</InputLabel>
                      <Select
                        labelId="type-label"
                        value={this.state.bag_type}
                        onChange={(e) =>
                          this.setState({ bag_type: e.target.value })
                        }
                        displayEmpty
                        label="Bag Type *"
                        fullWidth={true}
                      >
                        <MenuItem key={1} value={"regular"}>
                          Regular
                        </MenuItem>
                        <MenuItem key={2} value={"on_demand"}>
                          On Demand
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showAvailableBags: false })}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() => addBarcodeToUser()}
                >
                  {t("Add")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Dialog
          open={this.state.showRemoveUserFromCommunityConfirmationDialog}
          onClose={() =>
            this.setState({
              showRemoveUserFromCommunityConfirmationDialog: false,
            })
          }
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want to remove the user from this community?"}
          </DialogTitle>
          <DialogActions>
            <Button
              size="small"
              className="customCloseButton"
              onClick={() =>
                this.setState({
                  showRemoveUserFromCommunityConfirmationDialog: false,
                })
              }
            >
              Close
            </Button>
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ outline: "none !important" }}
              onClick={() => this.handleRemoveUserFromCommunity()}
              autoFocus
            >
              Remove
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.showAddUserToCommunityDialog}
          onClose={() => this.setState({ showAddUserToCommunityDialog: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-title">
            {"Add to Community"}
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth={true}>
              <Autocomplete
                id="combo-box-demo"
                fullWidth={true}
                options={this.state.routes}
                value={this.state.community_id?.id}
                onChange={(value: any, newValue: any) =>
                  this.setState({ community_id: newValue.id })
                }
                getOptionLabel={(options: any) => options.name}
                renderInput={(params) => (
                  <TextField {...params} label="Community" />
                )}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              className="customCloseButton"
              onClick={() =>
                this.setState({ showAddUserToCommunityDialog: false })
              }
            >
              Close
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{ outline: "none !important" }}
              onClick={() => this.handleAddUserToCommunity()}
              autoFocus
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.showDeleteBarcodeConfirmationDialog}
          onClose={() =>
            this.setState({
              showDeleteBarcodeConfirmationDialog: false,
              barcodeToBeDeleted: null,
            })
          }
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want to delete this Barcode?"}
          </DialogTitle>
          <DialogActions>
            <Button
              size="small"
              className="customCloseButton"
              onClick={() =>
                this.setState({
                  showDeleteBarcodeConfirmationDialog: false,
                  barcodeToBeDeleted: null,
                })
              }
            >
              Close
            </Button>
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ outline: "none !important" }}
              onClick={() => this.handleDeleteBarcode()}
              autoFocus
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <Modal
          open={this.state.showTransactionDetails}
          onClose={() => this.setState({ showTransactionDetails: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="Transaction Details"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showTransactionDetails: false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent sx={{ maxHeight: "500px", overflowY: "scroll" }}>
                <TableContainer>
                  <Table aria-label="simple table">
                    <TableBody>
                      <TableRow>
                        <TableCell
                          component="th"
                          sx={{ fontWeight: "bold", width: "30%" }}
                        >
                          Title
                        </TableCell>
                        <TableCell align="left" sx={{ width: "70%" }}>
                          {this.state.transactionDetails?.title}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          component="th"
                          sx={{ fontWeight: "bold", width: "30%" }}
                        >
                          Amount
                        </TableCell>
                        <TableCell align="left" sx={{ width: "70%" }}>
                          {this.state.transactionDetails?.amount}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          component="th"
                          sx={{ fontWeight: "bold", width: "30%" }}
                        >
                          Status
                        </TableCell>
                        <TableCell align="left" sx={{ width: "70%" }}>
                          {this.state.transactionDetails?.status}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          component="th"
                          sx={{ fontWeight: "bold", width: "30%" }}
                        >
                          Updated At
                        </TableCell>
                        <TableCell align="left" sx={{ width: "70%" }}>
                          {this.state.transactionDetails?.updated_at}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          component="th"
                          sx={{ fontWeight: "bold", width: "30%" }}
                        >
                          Transfer Id
                        </TableCell>
                        <TableCell align="left" sx={{ width: "70%" }}>
                          {this.state.transactionDetails?.transfer_id}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          component="th"
                          sx={{ fontWeight: "bold", width: "30%" }}
                        >
                          Beneficiary Type
                        </TableCell>
                        <TableCell align="left" sx={{ width: "70%" }}>
                          {this.state.transactionDetails?.beneficiary_type}
                        </TableCell>
                      </TableRow>
                      {this.state.transactionDetails?.beneficiary_type ==
                        "upi" && (
                        <TableRow>
                          <TableCell
                            component="th"
                            sx={{ fontWeight: "bold", width: "30%" }}
                          >
                            UPI Id
                          </TableCell>
                          <TableCell align="left" sx={{ width: "70%" }}>
                            {this.state.transactionDetails?.upi_key}
                          </TableCell>
                        </TableRow>
                      )}
                      {this.state.transactionDetails?.beneficiary_type ==
                        "paytm" && (
                        <TableRow>
                          <TableCell
                            component="th"
                            sx={{ fontWeight: "bold", width: "30%" }}
                          >
                            Paytm No
                          </TableCell>
                          <TableCell align="left" sx={{ width: "70%" }}>
                            {this.state.transactionDetails?.paytm_phone}
                          </TableCell>
                        </TableRow>
                      )}
                      {this.state.transactionDetails?.beneficiary_type ==
                        "banktransfer" && (
                        <TableRow>
                          <TableCell
                            component="th"
                            sx={{ fontWeight: "bold", width: "30%" }}
                          >
                            Bank IFSC
                          </TableCell>
                          <TableCell align="left" sx={{ width: "70%" }}>
                            {this.state.transactionDetails?.bank_ifsc}
                          </TableCell>
                        </TableRow>
                      )}
                      {this.state.transactionDetails?.beneficiary_type ==
                        "banktransfer" && (
                        <TableRow>
                          <TableCell
                            component="th"
                            sx={{ fontWeight: "bold", width: "30%" }}
                          >
                            Bank AC No
                          </TableCell>
                          <TableCell align="left" sx={{ width: "70%" }}>
                            {this.state.transactionDetails?.bank_ac_number}
                          </TableCell>
                        </TableRow>
                      )}
                      {this.state.transactionDetails?.cs_response && (
                        <TableRow>
                          <TableCell
                            component="th"
                            sx={{ fontWeight: "bold", width: "30%" }}
                          >
                            Response 1
                          </TableCell>
                          <TableCell align="left" sx={{ width: "70%" }}>
                            <Typography variant="body1" component="pre">
                              {JSON.stringify(
                                JSON.parse(
                                  this.state.transactionDetails.cs_response
                                ),
                                null,
                                4
                              )}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                      {this.state.transactionDetails?.cs_response_2 && (
                        <TableRow>
                          <TableCell
                            component="th"
                            sx={{ fontWeight: "bold", width: "30%" }}
                          >
                            Response 2
                          </TableCell>
                          <TableCell align="left" sx={{ width: "70%" }}>
                            <Typography variant="body1" component="pre">
                              {JSON.stringify(
                                JSON.parse(
                                  this.state.transactionDetails.cs_response_2
                                ),
                                null,
                                4
                              )}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showEditBag}
          onClose={() => this.setState({ showEditBag: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={t("Update Bag")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showEditBag: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="route-address-input"
                      label={t("UID")}
                      value={this.state.bagDetails.uid}
                      onChange={(e: any) =>
                        this.setState({
                          bagDetails: {
                            ...this.state.bagDetails,
                            uid: e.target.value,
                          },
                        })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="route-address-input"
                      label={t("Weight")}
                      value={this.state.bagDetails.weight}
                      onChange={(e: any) =>
                        this.setState({
                          bagDetails: {
                            ...this.state.bagDetails,
                            weight: e.target.value,
                          },
                        })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showEditBag: false })}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() => handleEditBag()}
                >
                  {t("Update")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAddBag}
          onClose={() => this.setState({ showAddBag: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={t("Add Bag")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showAddBag: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="route-address-input"
                      label={t("UID")}
                      value={this.state.bagUid}
                      onChange={(e: any) =>
                        this.setState({ bagUid: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="route-address-input"
                      label={t("Weight")}
                      value={this.state.bagWeight}
                      onChange={(e: any) =>
                        this.setState({ bagWeight: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions className="float-left">
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() =>
                    this.setState({ forceAddBag: true }, () => handleAddBag())
                  }
                >
                  <WarningAmberOutlinedIcon />
                  {t("Force Add")}
                </Button>
              </CardActions>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showAddBag: false })}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() => handleAddBag()}
                >
                  {t("Add")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        {this.state.showPickupDetails && (
          <Modal
            open={this.state.showPickupDetails}
            onClose={this.closeModal}
            aria-labelledby="bag-details-modal"
            aria-describedby="bag-details-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 600,
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 3,
                borderRadius: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Bag Details
                </Typography>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => this.setState({ showAddBag: true })}
                >
                  {t("Add Bag")}
                </Button>
              </Box>
              <DataGrid
                aria-label="Bags"
                columns={bagsColumn}
                rows={this.state.pickup_details.bags}
                components={{
                  MoreActionsIcon: EditOutlined,
                }}
                pageSize={10}
                rowsPerPageOptions={[10, 20, 50]}
                disableVirtualization
                sx={{ height: "400px" }}
              />
              <Box
                sx={{
                  mt: 3,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={this.closeModal}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={this.handleViewMore}
                  sx={{
                    textTransform: "none",
                    fontSize: "14px",
                  }}
                >
                  View More
                </Button>
              </Box>
            </Box>
          </Modal>
        )}
        <Dialog
          open={this.state.showDeleteBagsConfirmationDialog}
          onClose={() =>
            this.setState({ showDeleteBagsConfirmationDialog: false })
          }
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion"}
          </DialogTitle>
          <DialogContent>
            <Typography id="alert-dialog-description">
              Are you sure you want to delete the selected bags?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() =>
                this.setState({ showDeleteBagsConfirmationDialog: false })
              }
              className="customCloseButton"
            >
              No
            </Button>
            <Button
              onClick={this.handleConfirmDeleteBags}
              variant="contained"
              color="primary"
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Modal
          open={this.state.showAddBarcodeSetModal}
          onClose={() => this.setState({ showAddBarcodeSetModal: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={t("Alerts Body")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showAddBarcodeSetModal: false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="amount-input"
                      label="Barcode *"
                      type={"text"}
                      InputProps={{
                        inputProps: { min: 0 },
                      }}
                      value={this.state.barcode}
                      onChange={(e: any) =>
                        this.setState({ barcode: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="type-label">Bag Type *</InputLabel>
                      <Select
                        labelId="type-label"
                        value={this.state.bag_type}
                        onChange={(e) =>
                          this.setState({ bag_type: e.target.value })
                        }
                        displayEmpty
                        label="Bag Type *"
                        fullWidth={true}
                      >
                        <MenuItem key={1} value={"regular"}>
                          Regular
                        </MenuItem>
                        <MenuItem key={2} value={"on_demand"}>
                          On Demand
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() =>
                    this.setState({ showAddBarcodeSetModal: false })
                  }
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() => addBarcodeSetToUser()}
                >
                  {t("Add")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showHistoryPopup}
          onClose={() => this.setState({ showHistoryPopup: false })}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Card
            sx={{
              width: 550,
              borderRadius: 4,
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
              border: "1px solid rgba(226, 232, 240, 0.8)",
              position: "relative",
            }}
          >
            <CardContent sx={{ p: 4, textAlign: "center" }}>
              <IconButton
                aria-label="close"
                onClick={() => this.setState({ showHistoryPopup: false })}
                sx={{
                  position: "absolute",
                  right: 16,
                  top: 16,
                  color: (theme) => theme.palette.grey[500],
                  zIndex: 1,
                }}
                size="large"
              >
                <CloseOutlined />
              </IconButton>
              <Box
                sx={{
                  mb: 4,
                  pb: 2,
                  borderBottom: "2px solid",
                  borderImage:
                    "linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899) 1",
                }}
              >
                <Typography
                  variant="h4"
                  fontWeight={700}
                  sx={{
                    fontSize: "24px",
                    background:
                      "linear-gradient(135deg, #1e293b 0%, #475569 100%)",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    mb: 1,
                  }}
                >
                  Community Timeline
                </Typography>
              </Box>
              <Box sx={{ height: "500px", overflowY: "scroll" }}>
                <Timeline
                  sx={{
                    mt: 2,
                    "& .MuiTimelineItem-root": {
                      "&:before": { display: "none" },
                    },
                  }}
                >
                  {this.state.communityHistory.length === 0 ? (
                    <TimelineItem>
                      <TimelineSeparator>
                        <TimelineDot color="grey" />
                      </TimelineSeparator>
                      <TimelineContent>
                        <Typography color="text.secondary">
                          No community history found.
                        </Typography>
                      </TimelineContent>
                    </TimelineItem>
                  ) : (
                    this.state.communityHistory.map((item, idx) => {
                      const colorPalette = [
                        {
                          dot: "primary" as const,
                          bg: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                          border: "#bfdbfe",
                          text: "primary.main",
                        },
                        {
                          dot: "success" as const,
                          bg: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
                          border: "#bbf7d0",
                          text: "success.main",
                        },
                        {
                          dot: "secondary" as const,
                          bg: "linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%)",
                          border: "#d8b4fe",
                          text: "secondary.main",
                        },
                        {
                          dot: "warning" as const,
                          bg: "linear-gradient(135deg, #fef9c3 0%, #fde68a 100%)",
                          border: "#fde68a",
                          text: "warning.main",
                        },
                        {
                          dot: "info" as const,
                          bg: "linear-gradient(135deg, #cffafe 0%, #a7f3d0 100%)",
                          border: "#a7f3d0",
                          text: "info.main",
                        },
                      ];
                      const palette = colorPalette[idx % colorPalette.length];

                      return (
                        <TimelineItem key={idx}>
                          <TimelineOppositeContent
                            sx={{
                              flex: 1,
                              textAlign: "center",
                              pr: 1,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Box
                              sx={{
                                background: palette.bg,
                                borderRadius: 3,
                                p: 2,
                                border: `1px solid ${palette.border}`,
                                boxShadow: `0 2px 8px rgba(59, 130, 246, 0.08)`,
                                width: "100%",
                                maxWidth: 160,
                              }}
                            >
                              <Typography
                                variant="body2"
                                fontWeight={700}
                                sx={{ color: "grey.800" }}
                              >
                                {item.join_date}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{ color: palette.text, fontWeight: 600 }}
                              >
                                Joined
                              </Typography>
                            </Box>
                          </TimelineOppositeContent>
                          <TimelineSeparator
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              mx: 1,
                            }}
                          >
                            <TimelineDot
                              color={palette.dot}
                              sx={{
                                width: 16,
                                height: 16,
                                boxShadow: `0 4px 12px rgba(59, 130, 246, 0.2)`,
                                border: "3px solid #ffffff",
                              }}
                            />
                            {idx !== this.state.communityHistory.length - 1 && (
                              <TimelineConnector
                                sx={{
                                  minHeight: 40,
                                  background:
                                    "linear-gradient(180deg, #e2e8f0, #cbd5e1)",
                                  width: 2,
                                }}
                              />
                            )}
                          </TimelineSeparator>
                          <TimelineContent
                            sx={{
                              flex: 1,
                              pl: 1,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Box
                              sx={{
                                background: palette.bg,
                                borderRadius: 3,
                                p: 2,
                                border: `1px solid ${palette.border}`,
                                boxShadow: `0 2px 8px rgba(59, 130, 246, 0.08)`,
                                textAlign: "center",
                                width: "100%",
                                maxWidth: 160,
                              }}
                            >
                              <Typography
                                variant="body2"
                                fontWeight={700}
                                sx={{ color: palette.text }}
                              >
                                {item.community_name}
                              </Typography>
                            </Box>
                          </TimelineContent>
                        </TimelineItem>
                      );
                    })
                  )}
                </Timeline>
                <Box
                  sx={{
                    mt: 3,
                    pt: 2,
                    borderTop: "1px solid rgba(226, 232, 240, 0.6)",
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    {this.state.communityHistory.length === 0
                      ? "No timeline to display"
                      : "Timeline Complete ✨"}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Modal>
        <Modal
          open={this.state.showNotesPopup}
          onClose={() => this.setState({ showNotesPopup: false })}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Card
            sx={{
              width: 500,
              maxHeight: "80vh",
              display: "flex",
              flexDirection: "column",
              borderRadius: 2,
              boxShadow: 6,
            }}
          >
            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid #e0e0e0",
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Notes & Messages
              </Typography>
              <IconButton
                onClick={() => this.setState({ showNotesPopup: false })}
                sx={{ position: "absolute", top: 8, right: 8 }}
              >
                <CloseOutlined />
              </IconButton>
            </Box>
            <CardContent
              sx={{
                flexGrow: 1,
                overflowY: "auto",
                p: 2,
                backgroundColor: "#f9fafb",
              }}
            >
              {this.state.notes && this.state.notes.length > 0 ? (
                <>
                  {this.state.notes.map((note, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 2,
                        p: 2,
                        backgroundColor: "#ffffff",
                        border: "1px solid #e2e8f0",
                        borderRadius: 2,
                        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                      }}
                    >
                      {/* Header Row */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <Typography variant="caption" color="textSecondary">
                          {new Date(note.timestamp).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 600, color: "#1e293b" }}
                        >
                          {note.sender}
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#334155",
                          lineHeight: 1.6,
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {note.message}
                      </Typography>
                    </Box>
                  ))}
                  <div ref={this.notesEndRef} />
                </>
              ) : (
                <Box sx={{ textAlign: "center", py: 4 }}>
                  <Typography variant="body1" color="textSecondary">
                    No notes yet
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Start a conversation by adding your first note below
                  </Typography>
                </Box>
              )}
            </CardContent>
            <CardActions
              sx={{
                p: 2,
                borderTop: "1px solid #e0e0e0",
                flexDirection: "column",
                gap: 1,
                backgroundColor: "#f8fafc",
              }}
            >
              <TextareaAutosize
                minRows={3}
                maxRows={6}
                placeholder="Type your message here..."
                value={this.state.newNoteText || ""}
                onChange={(e) => this.setState({ newNoteText: e.target.value })}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #cbd5e1",
                  borderRadius: "6px",
                  fontFamily: "inherit",
                  fontSize: "14px",
                  resize: "vertical",
                  backgroundColor: "#ffffff",
                }}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <Button
                  variant="contained"
                  onClick={this.handleSendNote}
                  disabled={!this.state.newNoteText?.trim()}
                  sx={{
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  Send
                </Button>
              </Box>
            </CardActions>
          </Card>
        </Modal>
        <Modal
        open={this.state.showPauseModal}
        onClose={() => this.setState({ showPauseModal: false })}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 3,
            p: 4,
            display: "flex",
            flexDirection: "column",
            gap: 2
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Pause Pickup Service
          </Typography>

          <TextField
            label="Start Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: new Date().toISOString().split("T")[0] }}
            value={this.state.pause_start_date || ""}
            onChange={(e) =>
              this.setState({ pause_start_date: e.target.value })
            }
            fullWidth
          />

          <TextField
            label="End Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: new Date().toISOString().split("T")[0] }}
            value={this.state.pause_end_date || ""}
            onChange={(e) =>
              this.setState({ pause_end_date: e.target.value })
            }
            fullWidth
          />
          <TextField
            label="Remarks (Optional)"
            fullWidth
            multiline
            rows={3}
            value={this.state.pause_remarks}
            onChange={(e) => this.setState({ pause_remarks: e.target.value })}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 1 }}>
            <Button
              onClick={() =>
                this.setState({
                  showPauseModal: false,
                  pause_start_date: null,
                  pause_end_date: null
                })
              }
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={this.handlePausePickup}
              sx={{
                backgroundColor: "#1b5e20",
                "&:hover": {
                  backgroundColor: "#145214",
                }
              }}
            >
              Pause
            </Button>
          </Box>
        </Box>
      </Modal>
      <Dialog
        open={this.state.showDeleteBagConfirmation}
        onClose={() => this.setState({ showDeleteBagConfirmation: false, bagToDelete: null })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
      <DialogTitle id="alert-dialog-title">
          {t("Are you sure you want to delete this bag?")}
      </DialogTitle>
      <DialogActions>
          <Button className='customCloseButton' onClick={() => this.setState({ showDeleteBagConfirmation: false, bagToDelete: null })}>{t("Cancel")}</Button>
          <Button onClick={() => {
          if (this.state.bagToDelete) {
              handleDeleteBag(this.state.bagToDelete);
          }
          this.setState({ showDeleteBagConfirmation: false, bagToDelete: null });
          }} color="error" variant="contained" autoFocus>{t("Delete")}</Button>
      </DialogActions>
      </Dialog>
      </div>
    );
  }
}

export default withRouter(withTranslation()(CustomerDetails));
